export const HidePasswordIcon = () => {
    return (
        <svg
            width="22"
            height="20"
            viewBox="0 0 22 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.74294 3.09232C10.1494 3.03223 10.5686 3 11.0004 3C16.1054 3 19.4553 7.50484 20.5807 9.28682C20.7169 9.5025 20.785 9.61034 20.8231 9.77667C20.8518 9.90159 20.8517 10.0987 20.8231 10.2236C20.7849 10.3899 20.7164 10.4985 20.5792 10.7156C20.2793 11.1901 19.8222 11.8571 19.2165 12.5805M5.72432 4.71504C3.56225 6.1817 2.09445 8.21938 1.42111 9.28528C1.28428 9.50187 1.21587 9.61016 1.17774 9.77648C1.1491 9.9014 1.14909 10.0984 1.17771 10.2234C1.21583 10.3897 1.28393 10.4975 1.42013 10.7132C2.54554 12.4952 5.89541 17 11.0004 17C13.0588 17 14.8319 16.2676 16.2888 15.2766M2.00042 1L20.0004 19M8.8791 7.87868C8.3362 8.42157 8.00042 9.17157 8.00042 10C8.00042 11.6569 9.34356 13 11.0004 13C11.8288 13 12.5788 12.6642 13.1217 12.1213"
                stroke="#9A9A9A"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const PasswordVisible = () => {
    return (
        <svg
            width="22"
            height="16"
            viewBox="0 0 22 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.257 6.962C20.731 7.582 20.731 8.419 20.257 9.038C18.764 10.987 15.182 15 11 15C6.81801 15 3.23601 10.987 1.74301 9.038C1.51239 8.74113 1.38721 8.37592 1.38721 8C1.38721 7.62408 1.51239 7.25887 1.74301 6.962C3.23601 5.013 6.81801 1 11 1C15.182 1 18.764 5.013 20.257 6.962V6.962Z"
                stroke="#8F95B2"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M11 11C12.6569 11 14 9.65685 14 8C14 6.34315 12.6569 5 11 5C9.34315 5 8 6.34315 8 8C8 9.65685 9.34315 11 11 11Z"
                stroke="#8F95B2"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const ArrowIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.75 12H20.25"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M13.5 5.25L20.25 12L13.5 18.75"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const GoogleIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_214_3317)">
                <path
                    d="M4.43242 12.0846L3.73625 14.6835L1.19176 14.7373C0.431328 13.3269 0 11.7132 0 9.99832C0 8.34008 0.403281 6.77633 1.11812 5.39941H1.11867L3.38398 5.81473L4.37633 8.06645C4.16863 8.67195 4.05543 9.32195 4.05543 9.99832C4.05551 10.7324 4.18848 11.4357 4.43242 12.0846Z"
                    fill="#FBBB00"
                />
                <path
                    d="M19.8261 8.13184C19.941 8.73676 20.0009 9.36148 20.0009 9.99996C20.0009 10.7159 19.9256 11.4143 19.7822 12.0879C19.2954 14.3802 18.0234 16.3818 16.2613 17.7983L16.2608 17.7978L13.4075 17.6522L13.0037 15.1313C14.1729 14.4456 15.0866 13.3725 15.568 12.0879H10.2207V8.13184H15.646H19.8261Z"
                    fill="#518EF8"
                />
                <path
                    d="M16.2595 17.7965L16.2601 17.797C14.5464 19.1745 12.3694 19.9987 9.99965 19.9987C6.19141 19.9987 2.88043 17.8701 1.19141 14.7377L4.43207 12.085C5.27656 14.3388 7.45074 15.9432 9.99965 15.9432C11.0952 15.9432 12.1216 15.647 13.0024 15.13L16.2595 17.7965Z"
                    fill="#28B446"
                />
                <path
                    d="M16.382 2.30219L13.1425 4.95437C12.2309 4.38461 11.1534 4.05547 9.99906 4.05547C7.39246 4.05547 5.17762 5.73348 4.37543 8.06812L1.11773 5.40109H1.11719C2.78148 2.1923 6.13422 0 9.99906 0C12.4254 0 14.6502 0.864297 16.382 2.30219Z"
                    fill="#1179EF"
                />
            </g>
            <defs>
                <clipPath id="clip0_214_3317">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const BackArrowIcon = () => {
    return (
        <svg
            width="8"
            height="14"
            viewBox="0 0 8 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M7 13L1 7L7 0.999999" stroke="black" />
        </svg>
    );
};
export const ForwardArrowIcon = () => {
    return (
        <svg
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.125 6.5C0.125 6.15482 0.404822 5.875 0.75 5.875L11.7411 5.875L7.18306 1.31694C6.93898 1.07286 6.93898 0.677137 7.18306 0.433058C7.42714 0.188981 7.82287 0.188981 8.06694 0.433058L13.6919 6.05806C13.936 6.30214 13.936 6.69787 13.6919 6.94194L8.06694 12.5669C7.82286 12.811 7.42713 12.811 7.18306 12.5669C6.93898 12.3229 6.93898 11.9271 7.18306 11.6831L11.7411 7.125L0.75 7.125C0.404822 7.125 0.125 6.84518 0.125 6.5Z"
                fill="white"
            />
        </svg>
    );
};
export const UserIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.6663 17.5V15.8333C16.6663 14.9493 16.3152 14.1014 15.69 13.4763C15.0649 12.8512 14.2171 12.5 13.333 12.5H6.66634C5.78229 12.5 4.93444 12.8512 4.30932 13.4763C3.6842 14.1014 3.33301 14.9493 3.33301 15.8333V17.5"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M10.0003 9.16667C11.8413 9.16667 13.3337 7.67428 13.3337 5.83333C13.3337 3.99238 11.8413 2.5 10.0003 2.5C8.15938 2.5 6.66699 3.99238 6.66699 5.83333C6.66699 7.67428 8.15938 9.16667 10.0003 9.16667Z"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const FilterIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 11.25L12 20.25" stroke="#1D83F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 3.75L12 8.25" stroke="#1D83F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18.75 18.75L18.7501 20.25" stroke="#1D83F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18.7501 3.75L18.75 15.75" stroke="#1D83F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21 15.75H16.5" stroke="#1D83F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5.25007 15.75L5.25 20.25" stroke="#1D83F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5.25 3.75L5.25007 12.75" stroke="#1D83F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3 12.75H7.5" stroke="#1D83F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14.25 8.25H9.75" stroke="#1D83F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export const ArrowWhiteIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 12H20.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.5 5.25L20.25 12L13.5 18.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}


export const SearchIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z"
                stroke="#1D2026"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M16.4434 16.4438L20.9997 21.0002"
                stroke="#1D2026"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const DropdownIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13 6L8 11L3 6"
                stroke="#1D2026"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const DropupIcon = () => {
    return (
        <svg
            width="18"
            height="10"
            viewBox="0 0 18 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.5 9L9 1.5L1.5 9"
                stroke="#1D2026"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const DevIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.625 9.375H9.375V14.625H14.625V9.375Z"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M18.75 4.5H5.25C4.83579 4.5 4.5 4.83579 4.5 5.25V18.75C4.5 19.1642 4.83579 19.5 5.25 19.5H18.75C19.1642 19.5 19.5 19.1642 19.5 18.75V5.25C19.5 4.83579 19.1642 4.5 18.75 4.5Z"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M19.5 9.75H21.75"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M19.5 14.25H21.75"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M2.25 9.75H4.5"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M2.25 14.25H4.5"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M14.25 19.5V21.75"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M9.75 19.5V21.75"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M14.25 2.25V4.5"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M9.75 2.25V4.5"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const Dropdown = () => {
    return (
        <svg
            width="12"
            height="7"
            viewBox="0 0 12 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 1L6 6L1 1"
                stroke="#8C94A3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const DropUp = () => {
    return (
        <svg
            width="12"
            height="7"
            viewBox="0 0 12 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 6L6 1L1 6"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const StarIcons = () => {
    return (
        <svg
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.27569 10.9208L10.4279 12.9179C10.8308 13.1732 11.3311 12.7935 11.2115 12.3232L10.3008 8.74052C10.2752 8.64073 10.2782 8.53573 10.3096 8.4376C10.3409 8.33946 10.3994 8.25218 10.4781 8.18577L13.3049 5.83306C13.6763 5.52392 13.4846 4.90751 13.0074 4.87654L9.31588 4.63696C9.21645 4.62986 9.12109 4.59465 9.04089 4.53545C8.96069 4.47625 8.89896 4.39548 8.86289 4.30255L7.48612 0.835486C7.44869 0.736852 7.38215 0.651935 7.29532 0.592013C7.2085 0.532092 7.1055 0.5 7 0.5C6.89451 0.5 6.79151 0.532092 6.70468 0.592013C6.61786 0.651935 6.55131 0.736852 6.51389 0.835486L5.13712 4.30255C5.10104 4.39548 5.03932 4.47625 4.95912 4.53545C4.87892 4.59465 4.78355 4.62986 4.68412 4.63696L0.992627 4.87654C0.515435 4.90751 0.323731 5.52392 0.695149 5.83306L3.52186 8.18577C3.60063 8.25218 3.65907 8.33946 3.69044 8.4376C3.72181 8.53573 3.72485 8.64073 3.6992 8.74052L2.85459 12.063C2.71111 12.6274 3.31143 13.083 3.79495 12.7767L6.72431 10.9208C6.8067 10.8683 6.90234 10.8405 7 10.8405C7.09767 10.8405 7.19331 10.8683 7.27569 10.9208Z"
                fill="#FD8E1F"
            />
        </svg>
    );
};
export const RatingIcon = () => {
    return (
        <svg
            width="15"
            height="17"
            viewBox="0 0 18 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.34462 13.901L13.2849 16.3974C13.7886 16.7165 14.4139 16.2419 14.2644 15.654L13.126 11.1756C13.0939 11.0509 13.0977 10.9197 13.137 10.797C13.1762 10.6743 13.2492 10.5652 13.3477 10.4822L16.8811 7.54132C17.3453 7.1549 17.1057 6.38439 16.5092 6.34567L11.8949 6.0462C11.7706 6.03732 11.6514 5.99332 11.5511 5.91931C11.4509 5.84531 11.3737 5.74435 11.3286 5.62819L9.60765 1.29436C9.56087 1.17106 9.47769 1.06492 9.36915 0.990017C9.26062 0.915115 9.13187 0.875 9 0.875C8.86813 0.875 8.73938 0.915115 8.63085 0.990017C8.52232 1.06492 8.43914 1.17106 8.39236 1.29436L6.6714 5.62819C6.62631 5.74435 6.54914 5.84531 6.4489 5.91931C6.34865 5.99332 6.22944 6.03732 6.10515 6.0462L1.49078 6.34567C0.894294 6.38439 0.654664 7.1549 1.11894 7.54132L4.65232 10.4822C4.75079 10.5652 4.82383 10.6743 4.86305 10.797C4.90226 10.9197 4.90606 11.0509 4.874 11.1756L3.81824 15.3288C3.63889 16.0343 4.38929 16.6038 4.99369 16.2209L8.65539 13.901C8.75837 13.8354 8.87792 13.8006 9 13.8006C9.12208 13.8006 9.24163 13.8354 9.34462 13.901Z"
                fill="#1D83F8"
            />
        </svg>
    );
};
export const StudentsIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 12.5C12.7614 12.5 15 10.2614 15 7.5C15 4.73858 12.7614 2.5 10 2.5C7.23858 2.5 5 4.73858 5 7.5C5 10.2614 7.23858 12.5 10 12.5Z"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-miterlimit="10"
            />
            <path
                d="M2.42114 16.8743C3.18955 15.5442 4.29443 14.4398 5.6248 13.672C6.95517 12.9042 8.46417 12.5 10.0002 12.5C11.5363 12.5 13.0453 12.9043 14.3756 13.6721C15.706 14.44 16.8108 15.5444 17.5792 16.8744"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const BackIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.25 12H3.75"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M10.5 5.25L3.75 12L10.5 18.75"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const ForwardIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.75 12H20.25"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M13.5 5.25L20.25 12L13.5 18.75"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const VectorIcon = () => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.25 2.625L9.625 7L5.25 11.375"
                stroke="white"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const Dot = () => {
    return (
        <svg
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.23864 5.86364C2.7803 5.86364 2.36174 5.75189 1.98295 5.52841C1.60417 5.30114 1.30114 4.99811 1.07386 4.61932C0.850379 4.24053 0.738636 3.82197 0.738636 3.36364C0.738636 2.90152 0.850379 2.48295 1.07386 2.10795C1.30114 1.72917 1.60417 1.42803 1.98295 1.20455C2.36174 0.977272 2.7803 0.863636 3.23864 0.863636C3.70076 0.863636 4.11932 0.977272 4.49432 1.20455C4.87311 1.42803 5.17424 1.72917 5.39773 2.10795C5.625 2.48295 5.73864 2.90152 5.73864 3.36364C5.73864 3.82197 5.625 4.24053 5.39773 4.61932C5.17424 4.99811 4.87311 5.30114 4.49432 5.52841C4.11932 5.75189 3.70076 5.86364 3.23864 5.86364Z"
                fill="white"
            />
        </svg>
    );
};
export const BlueWatchIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 5.625V10H14.375"
                stroke="#1D83F8"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M10 16.875C13.797 16.875 16.875 13.797 16.875 10C16.875 6.20304 13.797 3.125 10 3.125C6.20304 3.125 3.125 6.20304 3.125 10C3.125 13.797 6.20304 16.875 10 16.875Z"
                stroke="#1D83F8"
                stroke-width="1.3"
                stroke-miterlimit="10"
            />
            <path
                d="M15.3037 2.04504L17.9554 4.69669"
                stroke="#1D83F8"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M2.04492 4.69669L4.69657 2.04504"
                stroke="#1D83F8"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const WhiteatchIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                stroke="#A1A5B3"
                stroke-width="1.5"
                stroke-miterlimit="10"
            />
            <path
                d="M12 6.75V12H17.25"
                stroke="#A1A5B3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const CourseLabelIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 20V10"
                stroke="#A1A5B3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M18 20V4"
                stroke="#A1A5B3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M6 20V16"
                stroke="#A1A5B3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const StudentEmergIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.25 15C10.9424 15 13.125 12.8174 13.125 10.125C13.125 7.43261 10.9424 5.25 8.25 5.25C5.55761 5.25 3.375 7.43261 3.375 10.125C3.375 12.8174 5.55761 15 8.25 15Z"
                stroke="#A1A5B3"
                stroke-width="1.5"
                stroke-miterlimit="10"
            />
            <path
                d="M14.5703 5.43161C15.2408 5.24269 15.9441 5.19966 16.6326 5.3054C17.3212 5.41114 17.9791 5.66321 18.562 6.04462C19.1449 6.42604 19.6393 6.92795 20.012 7.51654C20.3846 8.10513 20.6268 8.76673 20.7221 9.45679C20.8175 10.1469 20.764 10.8493 20.565 11.517C20.366 12.1846 20.0263 12.8018 19.5687 13.327C19.1111 13.8523 18.5463 14.2734 17.9123 14.562C17.2782 14.8506 16.5897 14.9999 15.8931 15"
                stroke="#A1A5B3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M1.5 18.5059C2.26138 17.4229 3.27215 16.539 4.44698 15.9288C5.62182 15.3186 6.92623 15.0001 8.25008 15C9.57393 14.9999 10.8784 15.3184 12.0532 15.9285C13.2281 16.5386 14.239 17.4225 15.0004 18.5054"
                stroke="#A1A5B3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M15.8926 15C17.2166 14.999 18.5213 15.3171 19.6962 15.9273C20.8712 16.5375 21.8819 17.4218 22.6426 18.5054"
                stroke="#A1A5B3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const LanguageIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.5 10.5H16.5"
                stroke="#A1A5B3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M10.5 13.5H16.5"
                stroke="#A1A5B3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z"
                stroke="#A1A5B3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M7.5 3.75V20.25"
                stroke="#A1A5B3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const Icon1 = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.5 10.5H16.5"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M10.5 13.5H16.5"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M7.5 3.75V20.25"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const Icon2 = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.25 5.25V10.4153C5.25 14.1372 8.227 17.2222 11.9488 17.2498C12.8395 17.2566 13.7228 17.087 14.5476 16.7508C15.3725 16.4146 16.1226 15.9185 16.7548 15.291C17.3871 14.6636 17.8889 13.9172 18.2313 13.0949C18.5737 12.2727 18.75 11.3907 18.75 10.5V5.25C18.75 5.05109 18.671 4.86032 18.5303 4.71967C18.3897 4.57902 18.1989 4.5 18 4.5H6C5.80109 4.5 5.61032 4.57902 5.46967 4.71967C5.32902 4.86032 5.25 5.05109 5.25 5.25Z"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M9 21H15"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M12 17.25V21"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M18.583 12H19.5003C20.2959 12 21.059 11.6839 21.6216 11.1213C22.1842 10.5587 22.5003 9.79565 22.5003 9V7.5C22.5003 7.30109 22.4213 7.11032 22.2806 6.96967C22.14 6.82902 21.9492 6.75 21.7503 6.75H18.7503"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M5.43432 12H4.48828C3.69263 12 2.92957 11.6839 2.36696 11.1213C1.80435 10.5587 1.48828 9.79565 1.48828 9V7.5C1.48828 7.30109 1.5673 7.11032 1.70795 6.96967C1.8486 6.82902 2.03937 6.75 2.23828 6.75H5.23828"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const Icon3 = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.5 18L19.5 18C20.3284 18 21 17.3284 21 16.5V6C21 5.17157 20.3284 4.5 19.5 4.5L4.5 4.5C3.67157 4.5 3 5.17157 3 6V16.5C3 17.3284 3.67157 18 4.5 18Z"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M15 21H9"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const Icon4 = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9 12.0005H15"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M9 15.0005H15"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M5.25 3.75055H18.75C18.9489 3.75055 19.1397 3.82957 19.2803 3.97022C19.421 4.11087 19.5 4.30164 19.5 4.50055V18.7505C19.5 19.3473 19.2629 19.9196 18.841 20.3415C18.419 20.7635 17.8467 21.0005 17.25 21.0005H6.75C6.15326 21.0005 5.58097 20.7635 5.15901 20.3415C4.73705 19.9196 4.5 19.3473 4.5 18.7505V4.50055C4.5 4.30164 4.57902 4.11087 4.71967 3.97022C4.86032 3.82957 5.05109 3.75055 5.25 3.75055Z"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M7.5 2.25055V5.25055"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M12 2.25055V5.25055"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M16.5 2.25055V5.25055"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const Icon5 = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3 16.5L12 21.75L21 16.5"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M3 12L12 17.25L21 12"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M3 7.5L12 12.75L21 7.5L12 2.25L3 7.5Z"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const CopyIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.75 15.7493H20.25V3.74933H8.25V8.24933"
                stroke="#4E5566"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M15.75 8.24945H3.75V20.2495H15.75V8.24945Z"
                stroke="#4E5566"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const FacebookIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_514_2721)">
                <path
                    d="M13.3312 3.32083H15.1571V0.140833C14.8421 0.0975 13.7587 0 12.4971 0C9.86458 0 8.06125 1.65583 8.06125 4.69917V7.5H5.15625V11.055H8.06125V20H11.6229V11.0558H14.4104L14.8529 7.50083H11.6221V5.05167C11.6229 4.02417 11.8996 3.32083 13.3312 3.32083Z"
                    fill="#4E5566"
                />
            </g>
            <defs>
                <clipPath id="clip0_514_2721">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const TwitterIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_514_1676)">
                <path
                    d="M20 3.79875C19.2563 4.125 18.4637 4.34125 17.6375 4.44625C18.4875 3.93875 19.1363 3.14125 19.4412 2.18C18.6488 2.6525 17.7738 2.98625 16.8412 3.1725C16.0887 2.37125 15.0162 1.875 13.8462 1.875C11.5763 1.875 9.74875 3.7175 9.74875 5.97625C9.74875 6.30125 9.77625 6.61375 9.84375 6.91125C6.435 6.745 3.41875 5.11125 1.3925 2.6225C1.03875 3.23625 0.83125 3.93875 0.83125 4.695C0.83125 6.115 1.5625 7.37375 2.6525 8.1025C1.99375 8.09 1.3475 7.89875 0.8 7.5975C0.8 7.61 0.8 7.62625 0.8 7.6425C0.8 9.635 2.22125 11.29 4.085 11.6712C3.75125 11.7625 3.3875 11.8062 3.01 11.8062C2.7475 11.8062 2.4825 11.7913 2.23375 11.7362C2.765 13.36 4.2725 14.5538 6.065 14.5925C4.67 15.6838 2.89875 16.3412 0.98125 16.3412C0.645 16.3412 0.3225 16.3263 0 16.285C1.81625 17.4563 3.96875 18.125 6.29 18.125C13.835 18.125 17.96 11.875 17.96 6.4575C17.96 6.27625 17.9538 6.10125 17.945 5.9275C18.7588 5.35 19.4425 4.62875 20 3.79875Z"
                    fill="#4E5566"
                />
            </g>
            <defs>
                <clipPath id="clip0_514_1676">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const MessageBoxIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21 5.25L12 13.5L3 5.25"
                stroke="#4E5566"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M3 5.25H21V18C21 18.1989 20.921 18.3897 20.7803 18.5303C20.6397 18.671 20.4489 18.75 20.25 18.75H3.75C3.55109 18.75 3.36032 18.671 3.21967 18.5303C3.07902 18.3897 3 18.1989 3 18V5.25Z"
                stroke="#4E5566"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M10.3638 12L3.23145 18.538"
                stroke="#4E5566"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M20.7692 18.5381L13.6367 12"
                stroke="#4E5566"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const WhatsAppIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_514_3312)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.6319 3.34007C14.8778 1.58386 12.5449 0.616264 10.0596 0.615234C4.93836 0.615234 0.770424 4.78306 0.768364 9.90566C0.767677 11.5432 1.19546 13.1417 2.00856 14.5507L0.69043 19.3652L5.61585 18.0732C6.97301 18.8135 8.50091 19.2036 10.0558 19.2041H10.0597C15.1804 19.2041 19.3488 15.0359 19.3507 9.9131C19.3517 7.43042 18.3862 5.09617 16.6319 3.34007ZM10.0596 17.635H10.0564C8.67074 17.6344 7.31175 17.262 6.12592 16.5586L5.84405 16.3911L2.92123 17.1579L3.70137 14.3082L3.51769 14.016C2.74464 12.7865 2.33643 11.3654 2.33712 9.90623C2.33872 5.64846 5.80308 2.18445 10.0627 2.18445C12.1254 2.18513 14.0643 2.98943 15.5223 4.44912C16.9803 5.90881 17.7828 7.84904 17.7821 9.91253C17.7802 14.1706 14.3161 17.635 10.0596 17.635ZM14.2955 11.8513C14.0634 11.735 12.922 11.1736 12.7091 11.096C12.4965 11.0185 12.3415 10.9799 12.1869 11.2122C12.0321 11.4445 11.5873 11.9675 11.4518 12.1224C11.3163 12.2773 11.181 12.2968 10.9488 12.1805C10.7166 12.0644 9.96861 11.8191 9.08181 11.0282C8.39173 10.4126 7.92584 9.6524 7.79034 9.42009C7.65507 9.18754 7.7892 9.07402 7.8922 8.9463C8.14351 8.63422 8.39516 8.30704 8.47253 8.1522C8.55 7.99724 8.51121 7.86163 8.45307 7.74547C8.39516 7.62932 7.93088 6.48662 7.73747 6.02165C7.54887 5.56915 7.35764 5.63026 7.21505 5.62317C7.07978 5.61642 6.92494 5.61504 6.7701 5.61504C6.61538 5.61504 6.36384 5.67306 6.15098 5.90561C5.93823 6.13804 5.33856 6.6996 5.33856 7.84229C5.33856 8.98498 6.17043 10.0889 6.28648 10.2438C6.40252 10.3988 7.92355 12.7437 10.2523 13.7492C10.8062 13.9886 11.2386 14.1313 11.5758 14.2383C12.132 14.415 12.6379 14.39 13.038 14.3303C13.4841 14.2636 14.4114 13.7686 14.6051 13.2264C14.7985 12.6841 14.7985 12.2193 14.7403 12.1224C14.6824 12.0256 14.5276 11.9675 14.2955 11.8513Z"
                    fill="#4E5566"
                />
            </g>
            <defs>
                <clipPath id="clip0_514_3312">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const SectionIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.5 16.25V5C2.5 4.83424 2.56585 4.67527 2.68306 4.55806C2.80027 4.44085 2.95924 4.375 3.125 4.375H7.29167C7.4269 4.375 7.55848 4.41886 7.66667 4.5L9.83333 6.125C9.94152 6.20614 10.0731 6.25 10.2083 6.25H15.625C15.7908 6.25 15.9497 6.31585 16.0669 6.43306C16.1842 6.55027 16.25 6.70924 16.25 6.875V8.75"
                stroke="#1D83F8"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M2.5 16.25L4.84285 10.3929C4.88924 10.2769 4.96932 10.1775 5.07275 10.1075C5.17619 10.0374 5.29823 10 5.42315 10H9.18576C9.30916 10 9.42979 9.96348 9.53245 9.89503L11.0925 8.85497C11.1952 8.78652 11.3158 8.75 11.4392 8.75H17.8829C17.9819 8.75 18.0795 8.77353 18.1677 8.81866C18.2558 8.86379 18.332 8.92922 18.3899 9.00956C18.4478 9.0899 18.4858 9.18284 18.5007 9.28074C18.5156 9.37864 18.5071 9.47869 18.4758 9.57264L16.25 16.25H2.5Z"
                stroke="#1D83F8"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const PlayIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                stroke="#564FFD"
                stroke-width="1.3"
                stroke-miterlimit="10"
            />
            <path
                d="M12.5 10L8.75 7.5V12.5L12.5 10Z"
                stroke="#564FFD"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const Play = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.5923 7.57338L4.59374 2.0741C4.51795 2.02778 4.43118 2.00248 4.34237 2.00082C4.25356 1.99916 4.16591 2.02118 4.08843 2.06463C4.01096 2.10808 3.94646 2.17139 3.90156 2.24803C3.85667 2.32468 3.83301 2.41191 3.83301 2.50073V13.4993C3.83301 13.5881 3.85667 13.6754 3.90156 13.752C3.94646 13.8287 4.01096 13.892 4.08843 13.9354C4.16591 13.9789 4.25356 14.0009 4.34237 13.9992C4.43118 13.9976 4.51795 13.9723 4.59374 13.9259L13.5923 8.42666C13.6654 8.38199 13.7257 8.3193 13.7676 8.2446C13.8095 8.16989 13.8315 8.08567 13.8315 8.00002C13.8315 7.91437 13.8095 7.83015 13.7676 7.75545C13.7257 7.68074 13.6654 7.61805 13.5923 7.57338Z"
                fill="#1D2026"
            />
        </svg>
    );
};
export const PdfIcon = () => {
    return (
        <svg
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.5 13H1.49998C1.36737 13 1.2402 12.9473 1.14643 12.8535C1.05267 12.7598 0.999997 12.6326 1 12.5V1.5C0.999997 1.3674 1.05267 1.24022 1.14643 1.14645C1.2402 1.05268 1.36737 1 1.49998 1H7.50017L11 4.5V12.5C11 12.6326 10.9473 12.7598 10.8536 12.8535C10.7598 12.9473 10.6326 13 10.5 13Z"
                fill="white"
                stroke="#1D2026"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const PlayVideoIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                fill="#1D83F8"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-miterlimit="10"
            />
            <path
                d="M12.5 10L8.75 7.5V12.5L12.5 10Z"
                fill="white"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export const VideoIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0_1_3334"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="16"
            >
                <rect width="16" height="16" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_1_3334)">
                <path
                    d="M6.00016 14C5.81127 14 5.65305 13.936 5.5255 13.808C5.3975 13.6804 5.3335 13.5222 5.3335 13.3333V12.6667H2.66683C2.30016 12.6667 1.98638 12.5362 1.7255 12.2753C1.46416 12.014 1.3335 11.7 1.3335 11.3333V3.33333C1.3335 2.96667 1.46416 2.65267 1.7255 2.39133C1.98638 2.13044 2.30016 2 2.66683 2H13.3335C13.7002 2 14.0142 2.13044 14.2755 2.39133C14.5364 2.65267 14.6668 2.96667 14.6668 3.33333V11.3333C14.6668 11.7 14.5364 12.014 14.2755 12.2753C14.0142 12.5362 13.7002 12.6667 13.3335 12.6667H10.6668V13.3333C10.6668 13.5222 10.6031 13.6804 10.4755 13.808C10.3475 13.936 10.1891 14 10.0002 14H6.00016ZM2.66683 11.3333H13.3335V3.33333H2.66683V11.3333Z"
                    fill="#1F2029"
                />
                <path
                    d="M6.35883 8.95017V5.38351C6.35883 5.11684 6.4755 4.9224 6.70883 4.80017C6.94216 4.67795 7.16994 4.68906 7.39216 4.83351L10.1588 6.60017C10.3699 6.7224 10.4755 6.91128 10.4755 7.16684C10.4755 7.4224 10.3699 7.61129 10.1588 7.73351L7.39216 9.50017C7.16994 9.64462 6.94216 9.65573 6.70883 9.53351C6.4755 9.41128 6.35883 9.21684 6.35883 8.95017Z"
                    fill="#1F2029"
                />
            </g>
        </svg>
    );
};
export const BlackDropUpIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3 10L8 5L13 10"
                stroke="#1D2026"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const BlueIconWatch = () => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_1_3458)">
                <path
                    d="M8.00016 1.83331C4.3335 1.83331 1.3335 4.83331 1.3335 8.49998C1.3335 12.1666 4.3335 15.1666 8.00016 15.1666C11.6668 15.1666 14.6668 12.1666 14.6668 8.49998C14.6668 4.83331 11.6668 1.83331 8.00016 1.83331ZM10.8002 11.3L7.3335 9.16665V5.16665H8.3335V8.63331L11.3335 10.4333L10.8002 11.3Z"
                    fill="#1D83F8"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_3458">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
export const BlueStudentIcon = () => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_1_3469)">
                <path
                    d="M3.33317 9.28667V11.9533L7.99984 14.5L12.6665 11.9533V9.28667L7.99984 11.8333L3.33317 9.28667ZM7.99984 2.5L0.666504 6.5L7.99984 10.5L13.9998 7.22667V11.8333H15.3332V6.5L7.99984 2.5Z"
                    fill="#1D83F8"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_3469">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};


export const BlueBegginerIcon = () => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_1_3474)">
                <path
                    d="M13 -0.5H17V17.5H13V-0.5ZM-1 9.5H3V17.5H-1V9.5ZM6 4.5H10V17.5H6V4.5Z"
                    fill="#1D83F8"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_3474">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
export const BlueDocumentIcon = () => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_1_3481)">
                <path
                    d="M10.6668 1.16669H2.66683C1.9335 1.16669 1.3335 1.76669 1.3335 2.50002V11.8334H2.66683V2.50002H10.6668V1.16669ZM10.0002 3.83335L14.0002 7.83335V14.5C14.0002 15.2334 13.4002 15.8334 12.6668 15.8334H5.32683C4.5935 15.8334 4.00016 15.2334 4.00016 14.5L4.00683 5.16669C4.00683 4.43335 4.60016 3.83335 5.3335 3.83335H10.0002ZM9.3335 8.50002H13.0002L9.3335 4.83335V8.50002Z"
                    fill="#1D83F8"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_3481">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
export const BlueQuizIcon = () => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.6667 2.5H3.33333C2.59333 2.5 2 3.01429 2 3.64286V11.6429C2 12.2714 2.59333 12.7857 3.33333 12.7857H6L8 14.5L10 12.7857H12.6667C13.4 12.7857 14 12.2714 14 11.6429V3.64286C14 3.01429 13.4 2.5 12.6667 2.5ZM8.66667 11.6429H7.33333V10.5H8.66667V11.6429ZM10.0467 7.21429L9.44667 7.74C8.96667 8.15714 8.66667 8.5 8.66667 9.35714H7.33333V9.07143C7.33333 8.44286 7.63333 7.87143 8.11333 7.45429L8.94 6.73429C9.18667 6.52857 9.33333 6.24286 9.33333 5.92857C9.33333 5.3 8.73333 4.78571 8 4.78571C7.26667 4.78571 6.66667 5.3 6.66667 5.92857H5.33333C5.33333 4.66571 6.52667 3.64286 8 3.64286C9.47333 3.64286 10.6667 4.66571 10.6667 5.92857C10.6667 6.43143 10.4267 6.88857 10.0467 7.21429Z"
                fill="#1D83F8"
            />
        </svg>
    );
};
export const GotToTopIcon = () => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="40" height="40" rx="20" fill="white" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20 26.875C19.6548 26.875 19.375 26.5952 19.375 26.25V15.2589L14.8169 19.8169C14.5729 20.061 14.1771 20.061 13.9331 19.8169C13.689 19.5729 13.689 19.1771 13.9331 18.9331L19.5581 13.3081C19.8021 13.064 20.1979 13.064 20.4419 13.3081L26.0669 18.9331C26.311 19.1771 26.311 19.5729 26.0669 19.8169C25.8229 20.061 25.4271 20.061 25.1831 19.8169L20.625 15.2589V26.25C20.625 26.5952 20.3452 26.875 20 26.875Z"
                fill="#1E1E1E"
            />
        </svg>
    );
};
export const Facebook = () => {
    return (
        <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="44" height="44" rx="22" fill="#1D83F8" />
            <g clip-path="url(#clip0_1_3284)">
                <path
                    d="M32 22C32 16.4771 27.5229 12 22 12C16.4771 12 12 16.4771 12 22C12 26.9912 15.6568 31.1283 20.4375 31.8785V24.8906H17.8984V22H20.4375V19.7969C20.4375 17.2906 21.9305 15.9062 24.2146 15.9062C25.3084 15.9062 26.4531 16.1016 26.4531 16.1016V18.5625H25.1922C23.95 18.5625 23.5625 19.3334 23.5625 20.125V22H26.3359L25.8926 24.8906H23.5625V31.8785C28.3432 31.1283 32 26.9912 32 22Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_3284">
                    <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(12 12)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const InstagramWhiteIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_1_3296)">
                <path
                    d="M17 3H7C4.79086 3 3 4.79086 3 7V17C3 19.2091 4.79086 21 7 21H17C19.2091 21 21 19.2091 21 17V7C21 4.79086 19.2091 3 17 3Z"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M16 11.37C16.1233 12.2022 15.9813 13.0522 15.5938 13.799C15.2063 14.5458 14.5932 15.1514 13.8416 15.5297C13.0901 15.9079 12.2385 16.0396 11.4078 15.906C10.5771 15.7723 9.80977 15.3801 9.21485 14.7852C8.61993 14.1902 8.22774 13.4229 8.09408 12.5922C7.96042 11.7615 8.09208 10.9099 8.47034 10.1584C8.8486 9.40685 9.4542 8.79374 10.201 8.40624C10.9478 8.01874 11.7978 7.87665 12.63 8C13.4789 8.12586 14.2649 8.52146 14.8717 9.12831C15.4785 9.73515 15.8741 10.5211 16 11.37Z"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M17.5 7.5H17.51"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_3296">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};


export const Instagram = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Blue background */}
      <rect width="44" height="44" rx="22" fill="#1D83F8" />

      {/* Outer rounded square (camera body border) */}
      <rect
        x="13"
        y="13"
        width="18"
        height="18"
        rx="5"
        stroke="white"
        strokeWidth="2"
        fill="none"
      />

      {/* Inner lens ring */}
      <circle
        cx="22"
        cy="22"
        r="4"
        stroke="white"
        strokeWidth="2"
        fill="none"
      />

      {/* Small flash dot */}
      <circle cx="27" cy="17" r="1.5" fill="white" />
    </svg>
  );
};




export const Twitter = () => {
    return (
        <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="44" height="44" rx="22" fill="#1D83F8" />
            <path
                d="M18.2918 30.1248C25.8371 30.1248 29.9652 23.8721 29.9652 18.4514C29.9652 18.2756 29.9613 18.0959 29.9535 17.9201C30.7566 17.3394 31.4496 16.62 32 15.7959C31.2521 16.1286 30.458 16.346 29.6449 16.4404C30.5011 15.9272 31.1421 15.121 31.4492 14.1713C30.6438 14.6486 29.763 14.9853 28.8445 15.167C28.2257 14.5094 27.4075 14.0741 26.5164 13.9282C25.6253 13.7823 24.711 13.934 23.9148 14.3599C23.1186 14.7858 22.4848 15.4621 22.1115 16.2842C21.7382 17.1064 21.6462 18.0286 21.8496 18.9084C20.2187 18.8265 18.6233 18.4029 17.1667 17.6649C15.71 16.9269 14.4247 15.891 13.3941 14.6244C12.8703 15.5275 12.71 16.5962 12.9459 17.6132C13.1817 18.6302 13.7959 19.5193 14.6637 20.0998C14.0122 20.0791 13.375 19.9037 12.8047 19.5881V19.6389C12.8041 20.5866 13.1317 21.5053 13.7319 22.2388C14.3321 22.9723 15.1678 23.4753 16.0969 23.6623C15.4934 23.8274 14.86 23.8515 14.2457 23.7326C14.5079 24.5477 15.018 25.2605 15.7048 25.7717C16.3916 26.2829 17.2209 26.567 18.077 26.5842C16.6237 27.7257 14.8285 28.3449 12.9805 28.342C12.6527 28.3415 12.3253 28.3214 12 28.2818C13.8774 29.4863 16.0613 30.126 18.2918 30.1248Z"
                fill="white"
            />
        </svg>
    );
};
export const Linkdin = () => {
    return (
        <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="44" height="44" rx="22" fill="#1D83F8" />
            <g clip-path="url(#clip0_1_3290)">
                <path
                    d="M30.5195 12H13.4766C12.6602 12 12 12.6445 12 13.4414V30.5547C12 31.3516 12.6602 32 13.4766 32H30.5195C31.3359 32 32 31.3516 32 30.5586V13.4414C32 12.6445 31.3359 12 30.5195 12ZM17.9336 29.043H14.9648V19.4961H17.9336V29.043ZM16.4492 18.1953C15.4961 18.1953 14.7266 17.4258 14.7266 16.4766C14.7266 15.5273 15.4961 14.7578 16.4492 14.7578C17.3984 14.7578 18.168 15.5273 18.168 16.4766C18.168 17.4219 17.3984 18.1953 16.4492 18.1953ZM29.043 29.043H26.0781V24.4023C26.0781 23.2969 26.0586 21.8711 24.5352 21.8711C22.9922 21.8711 22.7578 23.0781 22.7578 24.3242V29.043H19.7969V19.4961H22.6406V20.8008H22.6797C23.0742 20.0508 24.043 19.2578 25.4844 19.2578C28.4883 19.2578 29.043 21.2344 29.043 23.8047V29.043Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_3290">
                    <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(12 12)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const LogoIcon = () => {
    return (
        <svg
            width="100%"
            height="234"
            viewBox="0 0 1476 234"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="path-1-outside-1_1_3278"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="1476"
                height="235"
                fill="black"
            >
                <rect fill="white" width="100%" height="235" />
                <path d="M32.1983 191.841V108.489L119.794 4.86187H192.69L32.1983 191.841ZM1 230.138V4.86187H56.497V230.138H1ZM126.393 230.138L45.0976 115.569L86.7954 80.8122L195.389 230.138H126.393Z" />
                <path d="M216.32 230.138V4.86187H271.817V230.138H216.32Z" />
                <path d="M307.722 230.138V4.86187H366.219L448.114 128.764V4.86187H503.611V230.138H448.114L363.219 101.731V230.138H307.722Z" />
                <path d="M639.635 234C618.036 234 598.937 229.065 582.338 219.196C565.739 209.112 552.74 195.381 543.34 178.003C533.941 160.41 529.241 140.242 529.241 117.5C529.241 94.7578 533.941 74.6975 543.34 57.3191C552.74 39.7261 565.739 25.9949 582.338 16.1257C598.937 6.0419 618.036 1 639.635 1C653.834 1 666.334 3.14549 677.133 7.43646C688.132 11.7274 697.632 17.6275 705.631 25.1367C713.631 32.4314 720.431 40.9061 726.03 50.5608L679.833 79.8467C677.033 75.1266 673.433 70.9429 669.033 67.2956C664.834 63.6483 660.134 60.8591 654.934 58.9282C649.934 56.7827 644.835 55.7099 639.635 55.7099C629.236 55.7099 620.036 58.3918 612.036 63.7555C604.037 68.9047 597.737 76.0921 593.138 85.3177C588.538 94.5433 586.238 105.271 586.238 117.5C586.238 129.515 588.438 140.242 592.837 149.682C597.237 159.122 603.537 166.524 611.736 171.888C620.136 177.252 629.935 179.934 641.135 179.934C649.134 179.934 656.234 178.432 662.434 175.428C668.633 172.21 673.533 167.812 677.133 162.233C680.733 156.441 682.533 149.79 682.533 142.28L735.33 131.66C735.33 154.402 731.23 173.39 723.03 188.623C714.831 203.856 703.532 215.227 689.132 222.736C674.933 230.245 658.434 234 639.635 234ZM635.735 149.039V103.983H735.33V137.131L703.832 149.039H635.735Z" />
                <path d="M831.193 234C821.394 234 811.794 232.605 802.395 229.816C792.995 226.813 784.396 222.736 776.596 217.587C768.997 212.438 762.697 206.645 757.697 200.209C752.698 193.558 749.698 186.585 748.698 179.29L803.895 162.877C805.695 168.241 808.795 172.854 813.194 176.715C817.594 180.363 823.294 182.401 830.293 182.83C835.893 183.045 840.793 181.436 844.993 178.003C849.392 174.57 851.592 170.064 851.592 164.486C851.592 160.839 850.292 157.406 847.692 154.188C845.293 150.755 841.393 148.288 835.993 146.786L804.495 138.097C793.695 135.093 784.396 130.48 776.596 124.258C768.997 118.036 763.097 110.42 758.897 101.409C754.897 92.3978 752.898 82.314 752.898 71.1575C752.898 49.0589 759.697 31.895 773.296 19.6657C787.096 7.22191 806.395 1 831.193 1C844.393 1 855.992 2.82366 865.991 6.47098C876.191 10.1183 884.89 15.9111 892.09 23.8494C899.49 31.5732 905.589 41.7643 910.389 54.4227L855.492 71.4793C854.492 67.1883 851.892 62.8973 847.692 58.6063C843.693 54.3154 838.193 52.1699 831.193 52.1699C824.394 52.1699 819.094 53.779 815.294 56.9972C811.694 60.2155 809.895 64.9355 809.895 71.1575C809.895 75.0193 811.394 78.4521 814.394 81.4558C817.394 84.2449 821.694 86.3904 827.294 87.8923L859.092 96.5815C875.091 100.872 887.59 109.347 896.59 122.006C905.589 134.449 910.089 148.717 910.089 164.808C910.089 179.612 906.889 192.163 900.49 202.461C894.29 212.76 885.29 220.591 873.491 225.954C861.692 231.318 847.592 234 831.193 234Z" />
                <path d="M984.068 230.138V59.5718H924.671V4.86187H1098.66V59.5718H1039.56V230.138H984.068Z" />
                <path d="M1121.84 230.138V4.86187H1262.53V59.5718H1177.33V90.7887H1246.33V143.889H1177.33V175.428H1264.63V230.138H1121.84Z" />
                <path d="M1297.61 230.138V4.86187H1384.6C1400.4 4.86187 1414.4 8.18738 1426.6 14.8384C1438.8 21.2749 1448.3 30.2859 1455.1 41.8715C1462.1 53.2426 1465.6 66.4374 1465.6 81.4558C1465.6 96.4742 1462.1 109.884 1455.1 121.684C1448.3 133.269 1438.8 142.388 1426.6 149.039C1414.4 155.475 1400.4 158.693 1384.6 158.693H1353.11V230.138H1297.61ZM1410.4 230.138L1363.61 141.637L1405.3 108.167L1474 230.138H1410.4ZM1353.11 103.983H1381.6C1386.6 103.983 1391 103.018 1394.8 101.087C1398.6 99.1561 1401.6 96.4742 1403.8 93.0414C1406 89.6087 1407.1 85.7468 1407.1 81.4558C1407.1 75.0193 1404.7 69.7629 1399.9 65.6865C1395.3 61.3955 1389.2 59.25 1381.6 59.25H1353.11V103.983Z" />
            </mask>
            <path
                d="M32.1983 191.841V108.489L119.794 4.86187H192.69L32.1983 191.841ZM1 230.138V4.86187H56.497V230.138H1ZM126.393 230.138L45.0976 115.569L86.7954 80.8122L195.389 230.138H126.393Z"
                fill="url(#paint0_linear_1_3278)"
            />
            <path
                d="M216.32 230.138V4.86187H271.817V230.138H216.32Z"
                fill="url(#paint1_linear_1_3278)"
            />
            <path
                d="M307.722 230.138V4.86187H366.219L448.114 128.764V4.86187H503.611V230.138H448.114L363.219 101.731V230.138H307.722Z"
                fill="url(#paint2_linear_1_3278)"
            />
            <path
                d="M639.635 234C618.036 234 598.937 229.065 582.338 219.196C565.739 209.112 552.74 195.381 543.34 178.003C533.941 160.41 529.241 140.242 529.241 117.5C529.241 94.7578 533.941 74.6975 543.34 57.3191C552.74 39.7261 565.739 25.9949 582.338 16.1257C598.937 6.0419 618.036 1 639.635 1C653.834 1 666.334 3.14549 677.133 7.43646C688.132 11.7274 697.632 17.6275 705.631 25.1367C713.631 32.4314 720.431 40.9061 726.03 50.5608L679.833 79.8467C677.033 75.1266 673.433 70.9429 669.033 67.2956C664.834 63.6483 660.134 60.8591 654.934 58.9282C649.934 56.7827 644.835 55.7099 639.635 55.7099C629.236 55.7099 620.036 58.3918 612.036 63.7555C604.037 68.9047 597.737 76.0921 593.138 85.3177C588.538 94.5433 586.238 105.271 586.238 117.5C586.238 129.515 588.438 140.242 592.837 149.682C597.237 159.122 603.537 166.524 611.736 171.888C620.136 177.252 629.935 179.934 641.135 179.934C649.134 179.934 656.234 178.432 662.434 175.428C668.633 172.21 673.533 167.812 677.133 162.233C680.733 156.441 682.533 149.79 682.533 142.28L735.33 131.66C735.33 154.402 731.23 173.39 723.03 188.623C714.831 203.856 703.532 215.227 689.132 222.736C674.933 230.245 658.434 234 639.635 234ZM635.735 149.039V103.983H735.33V137.131L703.832 149.039H635.735Z"
                fill="url(#paint3_linear_1_3278)"
            />
            <path
                d="M831.193 234C821.394 234 811.794 232.605 802.395 229.816C792.995 226.813 784.396 222.736 776.596 217.587C768.997 212.438 762.697 206.645 757.697 200.209C752.698 193.558 749.698 186.585 748.698 179.29L803.895 162.877C805.695 168.241 808.795 172.854 813.194 176.715C817.594 180.363 823.294 182.401 830.293 182.83C835.893 183.045 840.793 181.436 844.993 178.003C849.392 174.57 851.592 170.064 851.592 164.486C851.592 160.839 850.292 157.406 847.692 154.188C845.293 150.755 841.393 148.288 835.993 146.786L804.495 138.097C793.695 135.093 784.396 130.48 776.596 124.258C768.997 118.036 763.097 110.42 758.897 101.409C754.897 92.3978 752.898 82.314 752.898 71.1575C752.898 49.0589 759.697 31.895 773.296 19.6657C787.096 7.22191 806.395 1 831.193 1C844.393 1 855.992 2.82366 865.991 6.47098C876.191 10.1183 884.89 15.9111 892.09 23.8494C899.49 31.5732 905.589 41.7643 910.389 54.4227L855.492 71.4793C854.492 67.1883 851.892 62.8973 847.692 58.6063C843.693 54.3154 838.193 52.1699 831.193 52.1699C824.394 52.1699 819.094 53.779 815.294 56.9972C811.694 60.2155 809.895 64.9355 809.895 71.1575C809.895 75.0193 811.394 78.4521 814.394 81.4558C817.394 84.2449 821.694 86.3904 827.294 87.8923L859.092 96.5815C875.091 100.872 887.59 109.347 896.59 122.006C905.589 134.449 910.089 148.717 910.089 164.808C910.089 179.612 906.889 192.163 900.49 202.461C894.29 212.76 885.29 220.591 873.491 225.954C861.692 231.318 847.592 234 831.193 234Z"
                fill="url(#paint4_linear_1_3278)"
            />
            <path
                d="M984.068 230.138V59.5718H924.671V4.86187H1098.66V59.5718H1039.56V230.138H984.068Z"
                fill="url(#paint5_linear_1_3278)"
            />
            <path
                d="M1121.84 230.138V4.86187H1262.53V59.5718H1177.33V90.7887H1246.33V143.889H1177.33V175.428H1264.63V230.138H1121.84Z"
                fill="url(#paint6_linear_1_3278)"
            />
            <path
                d="M1297.61 230.138V4.86187H1384.6C1400.4 4.86187 1414.4 8.18738 1426.6 14.8384C1438.8 21.2749 1448.3 30.2859 1455.1 41.8715C1462.1 53.2426 1465.6 66.4374 1465.6 81.4558C1465.6 96.4742 1462.1 109.884 1455.1 121.684C1448.3 133.269 1438.8 142.388 1426.6 149.039C1414.4 155.475 1400.4 158.693 1384.6 158.693H1353.11V230.138H1297.61ZM1410.4 230.138L1363.61 141.637L1405.3 108.167L1474 230.138H1410.4ZM1353.11 103.983H1381.6C1386.6 103.983 1391 103.018 1394.8 101.087C1398.6 99.1561 1401.6 96.4742 1403.8 93.0414C1406 89.6087 1407.1 85.7468 1407.1 81.4558C1407.1 75.0193 1404.7 69.7629 1399.9 65.6865C1395.3 61.3955 1389.2 59.25 1381.6 59.25H1353.11V103.983Z"
                fill="url(#paint7_linear_1_3278)"
            />
            <path
                d="M32.1983 191.841V108.489L119.794 4.86187H192.69L32.1983 191.841ZM1 230.138V4.86187H56.497V230.138H1ZM126.393 230.138L45.0976 115.569L86.7954 80.8122L195.389 230.138H126.393Z"
                stroke="white"
                stroke-width="2"
                mask="url(#path-1-outside-1_1_3278)"
            />
            <path
                d="M216.32 230.138V4.86187H271.817V230.138H216.32Z"
                stroke="white"
                stroke-width="2"
                mask="url(#path-1-outside-1_1_3278)"
            />
            <path
                d="M307.722 230.138V4.86187H366.219L448.114 128.764V4.86187H503.611V230.138H448.114L363.219 101.731V230.138H307.722Z"
                stroke="white"
                stroke-width="2"
                mask="url(#path-1-outside-1_1_3278)"
            />
            <path
                d="M639.635 234C618.036 234 598.937 229.065 582.338 219.196C565.739 209.112 552.74 195.381 543.34 178.003C533.941 160.41 529.241 140.242 529.241 117.5C529.241 94.7578 533.941 74.6975 543.34 57.3191C552.74 39.7261 565.739 25.9949 582.338 16.1257C598.937 6.0419 618.036 1 639.635 1C653.834 1 666.334 3.14549 677.133 7.43646C688.132 11.7274 697.632 17.6275 705.631 25.1367C713.631 32.4314 720.431 40.9061 726.03 50.5608L679.833 79.8467C677.033 75.1266 673.433 70.9429 669.033 67.2956C664.834 63.6483 660.134 60.8591 654.934 58.9282C649.934 56.7827 644.835 55.7099 639.635 55.7099C629.236 55.7099 620.036 58.3918 612.036 63.7555C604.037 68.9047 597.737 76.0921 593.138 85.3177C588.538 94.5433 586.238 105.271 586.238 117.5C586.238 129.515 588.438 140.242 592.837 149.682C597.237 159.122 603.537 166.524 611.736 171.888C620.136 177.252 629.935 179.934 641.135 179.934C649.134 179.934 656.234 178.432 662.434 175.428C668.633 172.21 673.533 167.812 677.133 162.233C680.733 156.441 682.533 149.79 682.533 142.28L735.33 131.66C735.33 154.402 731.23 173.39 723.03 188.623C714.831 203.856 703.532 215.227 689.132 222.736C674.933 230.245 658.434 234 639.635 234ZM635.735 149.039V103.983H735.33V137.131L703.832 149.039H635.735Z"
                stroke="white"
                stroke-width="2"
                mask="url(#path-1-outside-1_1_3278)"
            />
            <path
                d="M831.193 234C821.394 234 811.794 232.605 802.395 229.816C792.995 226.813 784.396 222.736 776.596 217.587C768.997 212.438 762.697 206.645 757.697 200.209C752.698 193.558 749.698 186.585 748.698 179.29L803.895 162.877C805.695 168.241 808.795 172.854 813.194 176.715C817.594 180.363 823.294 182.401 830.293 182.83C835.893 183.045 840.793 181.436 844.993 178.003C849.392 174.57 851.592 170.064 851.592 164.486C851.592 160.839 850.292 157.406 847.692 154.188C845.293 150.755 841.393 148.288 835.993 146.786L804.495 138.097C793.695 135.093 784.396 130.48 776.596 124.258C768.997 118.036 763.097 110.42 758.897 101.409C754.897 92.3978 752.898 82.314 752.898 71.1575C752.898 49.0589 759.697 31.895 773.296 19.6657C787.096 7.22191 806.395 1 831.193 1C844.393 1 855.992 2.82366 865.991 6.47098C876.191 10.1183 884.89 15.9111 892.09 23.8494C899.49 31.5732 905.589 41.7643 910.389 54.4227L855.492 71.4793C854.492 67.1883 851.892 62.8973 847.692 58.6063C843.693 54.3154 838.193 52.1699 831.193 52.1699C824.394 52.1699 819.094 53.779 815.294 56.9972C811.694 60.2155 809.895 64.9355 809.895 71.1575C809.895 75.0193 811.394 78.4521 814.394 81.4558C817.394 84.2449 821.694 86.3904 827.294 87.8923L859.092 96.5815C875.091 100.872 887.59 109.347 896.59 122.006C905.589 134.449 910.089 148.717 910.089 164.808C910.089 179.612 906.889 192.163 900.49 202.461C894.29 212.76 885.29 220.591 873.491 225.954C861.692 231.318 847.592 234 831.193 234Z"
                stroke="white"
                stroke-width="2"
                mask="url(#path-1-outside-1_1_3278)"
            />
            <path
                d="M984.068 230.138V59.5718H924.671V4.86187H1098.66V59.5718H1039.56V230.138H984.068Z"
                stroke="white"
                stroke-width="2"
                mask="url(#path-1-outside-1_1_3278)"
            />
            <path
                d="M1121.84 230.138V4.86187H1262.53V59.5718H1177.33V90.7887H1246.33V143.889H1177.33V175.428H1264.63V230.138H1121.84Z"
                stroke="white"
                stroke-width="2"
                mask="url(#path-1-outside-1_1_3278)"
            />
            <path
                d="M1297.61 230.138V4.86187H1384.6C1400.4 4.86187 1414.4 8.18738 1426.6 14.8384C1438.8 21.2749 1448.3 30.2859 1455.1 41.8715C1462.1 53.2426 1465.6 66.4374 1465.6 81.4558C1465.6 96.4742 1462.1 109.884 1455.1 121.684C1448.3 133.269 1438.8 142.388 1426.6 149.039C1414.4 155.475 1400.4 158.693 1384.6 158.693H1353.11V230.138H1297.61ZM1410.4 230.138L1363.61 141.637L1405.3 108.167L1474 230.138H1410.4ZM1353.11 103.983H1381.6C1386.6 103.983 1391 103.018 1394.8 101.087C1398.6 99.1561 1401.6 96.4742 1403.8 93.0414C1406 89.6087 1407.1 85.7468 1407.1 81.4558C1407.1 75.0193 1404.7 69.7629 1399.9 65.6865C1395.3 61.3955 1389.2 59.25 1381.6 59.25H1353.11V103.983Z"
                stroke="white"
                stroke-width="2"
                mask="url(#path-1-outside-1_1_3278)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1_3278"
                    x1="769.958"
                    y1="0.570483"
                    x2="769.958"
                    y2="234.429"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.15" stop-color="#1D83F8" />
                    <stop offset="0.31" stop-color="#57A2F6" />
                    <stop offset="0.74" stop-color="#C9DEF3" />
                    <stop offset="0.9" stop-color="white" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1_3278"
                    x1="769.958"
                    y1="0.570483"
                    x2="769.958"
                    y2="234.429"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.15" stop-color="#1D83F8" />
                    <stop offset="0.31" stop-color="#57A2F6" />
                    <stop offset="0.74" stop-color="#C9DEF3" />
                    <stop offset="0.9" stop-color="white" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_1_3278"
                    x1="769.958"
                    y1="0.570483"
                    x2="769.958"
                    y2="234.429"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.15" stop-color="#1D83F8" />
                    <stop offset="0.31" stop-color="#57A2F6" />
                    <stop offset="0.74" stop-color="#C9DEF3" />
                    <stop offset="0.9" stop-color="white" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_1_3278"
                    x1="769.958"
                    y1="0.570483"
                    x2="769.958"
                    y2="234.429"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.15" stop-color="#1D83F8" />
                    <stop offset="0.31" stop-color="#57A2F6" />
                    <stop offset="0.74" stop-color="#C9DEF3" />
                    <stop offset="0.9" stop-color="white" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_1_3278"
                    x1="769.958"
                    y1="0.570483"
                    x2="769.958"
                    y2="234.429"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.15" stop-color="#1D83F8" />
                    <stop offset="0.31" stop-color="#57A2F6" />
                    <stop offset="0.74" stop-color="#C9DEF3" />
                    <stop offset="0.9" stop-color="white" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_1_3278"
                    x1="769.958"
                    y1="0.570483"
                    x2="769.958"
                    y2="234.429"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.15" stop-color="#1D83F8" />
                    <stop offset="0.31" stop-color="#57A2F6" />
                    <stop offset="0.74" stop-color="#C9DEF3" />
                    <stop offset="0.9" stop-color="white" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_1_3278"
                    x1="769.958"
                    y1="0.570483"
                    x2="769.958"
                    y2="234.429"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.15" stop-color="#1D83F8" />
                    <stop offset="0.31" stop-color="#57A2F6" />
                    <stop offset="0.74" stop-color="#C9DEF3" />
                    <stop offset="0.9" stop-color="white" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_1_3278"
                    x1="769.958"
                    y1="0.570483"
                    x2="769.958"
                    y2="234.429"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.15" stop-color="#1D83F8" />
                    <stop offset="0.31" stop-color="#57A2F6" />
                    <stop offset="0.74" stop-color="#C9DEF3" />
                    <stop offset="0.9" stop-color="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};
export const EnrolledCourseIcon = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.2"
                d="M16 4C13.6266 4 11.3066 4.70379 9.33316 6.02236C7.35977 7.34094 5.8217 9.21509 4.91345 11.4078C4.0052 13.6005 3.76756 16.0133 4.23058 18.3411C4.6936 20.6689 5.83649 22.8071 7.51472 24.4853C9.19295 26.1635 11.3312 27.3064 13.6589 27.7694C15.9867 28.2324 18.3995 27.9948 20.5922 27.0866C22.7849 26.1783 24.6591 24.6402 25.9776 22.6668C27.2962 20.6935 28 18.3734 28 16C28 14.4241 27.6896 12.8637 27.0866 11.4078C26.4835 9.95189 25.5996 8.62901 24.4853 7.51471C23.371 6.40041 22.0481 5.51649 20.5922 4.91344C19.1363 4.31038 17.5759 4 16 4ZM14 20V12L20 16L14 20Z"
                fill="#F93333"
            />
            <path
                d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                stroke="#F93333"
                stroke-width="2"
                stroke-miterlimit="10"
            />
            <path
                d="M20 16L14 12V20L20 16Z"
                stroke="#F93333"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const ActiveCourseIcon = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.2"
                d="M5.5 5.5V24.5L7.5 26.5H26.5V5.5H5.5Z"
                fill="#1D83F8"
            />
            <path
                d="M5.5 17.9091V6.5C5.5 6.23478 5.60536 5.98043 5.79289 5.79289C5.98043 5.60536 6.23478 5.5 6.5 5.5H25.5C25.7652 5.5 26.0196 5.60536 26.2071 5.79289C26.3946 5.98043 26.5 6.23478 26.5 6.5V25.5C26.5 25.7652 26.3946 26.0196 26.2071 26.2071C26.0196 26.3946 25.7652 26.5 25.5 26.5H16.9545"
                stroke="#1D83F8"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M16 19L8 27L4 23"
                stroke="#1D83F8"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const CopmletedCourseIcon = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.2"
                d="M7 7V13.887C7 18.8496 10.9693 22.963 15.9318 22.9997C17.1194 23.0088 18.297 22.7826 19.3968 22.3344C20.4966 21.8861 21.4968 21.2246 22.3398 20.388C23.1828 19.5514 23.8518 18.5563 24.3084 17.4599C24.7649 16.3635 25 15.1876 25 14V7C25 6.73478 24.8946 6.48043 24.7071 6.29289C24.5196 6.10536 24.2652 6 24 6H8C7.73478 6 7.48043 6.10536 7.29289 6.29289C7.10536 6.48043 7 6.73478 7 7Z"
                fill="#23BD33"
            />
            <path
                d="M7 7V13.887C7 18.8496 10.9693 22.963 15.9318 22.9997C17.1194 23.0088 18.297 22.7826 19.3968 22.3344C20.4966 21.8861 21.4968 21.2246 22.3398 20.388C23.1828 19.5514 23.8518 18.5563 24.3084 17.4599C24.7649 16.3635 25 15.1876 25 14V7C25 6.73478 24.8946 6.48043 24.7071 6.29289C24.5196 6.10536 24.2652 6 24 6H8C7.73478 6 7.48043 6.10536 7.29289 6.29289C7.10536 6.48043 7 6.73478 7 7Z"
                stroke="#23BD33"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M12 28H20"
                stroke="#23BD33"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M16 23V28"
                stroke="#23BD33"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M24.7773 16H26.0004C27.0613 16 28.0787 15.5786 28.8288 14.8284C29.579 14.0783 30.0004 13.0609 30.0004 12V10C30.0004 9.73478 29.895 9.48043 29.7075 9.29289C29.52 9.10536 29.2656 9 29.0004 9H25.0004"
                stroke="#23BD33"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M7.24576 16H5.98438C4.92351 16 3.90609 15.5786 3.15595 14.8284C2.4058 14.0783 1.98438 13.0609 1.98438 12V10C1.98438 9.73478 2.08973 9.48043 2.27727 9.29289C2.4648 9.10536 2.71916 9 2.98438 9H6.98438"
                stroke="#23BD33"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const BackArrow = () => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="40"
                height="40"
                transform="matrix(-1 0 0 1 40 0)"
                fill="#E8EBFF"
            />
            <path
                d="M28.25 20H11.75"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M18.5 13.25L11.75 20L18.5 26.75"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const ForwardArrow = () => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="40" height="40" fill="#E8EBFF" />
            <path
                d="M11.75 20H28.25"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M21.5 13.25L28.25 20L21.5 26.75"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const CrossIcon = () => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.0625 3.9375L3.9375 14.0625"
                stroke="#1D2026"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M14.0625 14.0625L3.9375 3.9375"
                stroke="#1D2026"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const HideMenuIcon = () => {
    return (
        <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="44" height="44" rx="22" fill="#1D83F8" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18 16.75C18 16.3358 18.3358 16 18.75 16H30.25C30.6642 16 31 16.3358 31 16.75C31 17.1642 30.6642 17.5 30.25 17.5H18.75C18.3358 17.5 18 17.1642 18 16.75ZM13 22C13 21.5858 13.3358 21.25 13.75 21.25H30.25C30.6642 21.25 31 21.5858 31 22C31 22.4142 30.6642 22.75 30.25 22.75H13.75C13.3358 22.75 13 22.4142 13 22ZM21.25 27.25C21.25 26.8358 21.5858 26.5 22 26.5H30.25C30.6642 26.5 31 26.8358 31 27.25C31 27.6642 30.6642 28 30.25 28H22C21.5858 28 21.25 27.6642 21.25 27.25Z"
                fill="white"
            />
        </svg>
    );
};
export const MoreIcons = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="48" height="48" rx="16" fill="#F5F7FA" />
            <path
                d="M24 25.525C24.8422 25.525 25.525 24.8422 25.525 24C25.525 23.1578 24.8422 22.475 24 22.475C23.1578 22.475 22.475 23.1578 22.475 24C22.475 24.8422 23.1578 25.525 24 25.525Z"
                fill="#1D2026"
                stroke="#1D2026"
                stroke-width="0.8"
            />
            <path
                d="M31 25.525C31.8422 25.525 32.525 24.8422 32.525 24C32.525 23.1578 31.8422 22.475 31 22.475C30.1578 22.475 29.475 23.1578 29.475 24C29.475 24.8422 30.1578 25.525 31 25.525Z"
                fill="#1D2026"
                stroke="#1D2026"
                stroke-width="0.8"
            />
            <path
                d="M17 25.525C17.8422 25.525 18.525 24.8422 18.525 24C18.525 23.1578 17.8422 22.475 17 22.475C16.1578 22.475 15.475 23.1578 15.475 24C15.475 24.8422 16.1578 25.525 17 25.525Z"
                fill="#1D2026"
                stroke="#1D2026"
                stroke-width="0.8"
            />
        </svg>
    );
};
export const SentIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.5815 11.3455L4.74572 2.47746C4.6125 2.40285 4.45968 2.37069 4.30769 2.38526C4.1557 2.39983 4.01177 2.46045 3.89515 2.55901C3.77854 2.65757 3.69478 2.78938 3.65507 2.93681C3.61537 3.08425 3.62161 3.24029 3.67297 3.38409L6.65994 11.7476C6.7182 11.9107 6.7182 12.089 6.65994 12.2521L3.67297 20.6156C3.62161 20.7594 3.61537 20.9155 3.65507 21.0629C3.69478 21.2104 3.77853 21.3422 3.89515 21.4407C4.01177 21.5393 4.1557 21.5999 4.30769 21.6145C4.45968 21.629 4.6125 21.5969 4.74573 21.5223L20.5815 12.6542C20.6978 12.5891 20.7947 12.4941 20.8621 12.3791C20.9295 12.2641 20.965 12.1332 20.965 11.9999C20.965 11.8665 20.9295 11.7356 20.8621 11.6206C20.7947 11.5056 20.6978 11.4106 20.5815 11.3455Z"
                fill="white"
            />
            <path
                d="M6.75 12H12.75"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const TypeMessageIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9 20.2499H4.5C4.30109 20.2499 4.11032 20.1709 3.96967 20.0302C3.82902 19.8896 3.75 19.6988 3.75 19.4999V15.3105C3.75 15.2121 3.7694 15.1145 3.80709 15.0235C3.84478 14.9325 3.90003 14.8499 3.96967 14.7802L15.2197 3.53022C15.3603 3.38956 15.5511 3.31055 15.75 3.31055C15.9489 3.31055 16.1397 3.38956 16.2803 3.53022L20.4697 7.71956C20.6103 7.86021 20.6893 8.05097 20.6893 8.24989C20.6893 8.4488 20.6103 8.63956 20.4697 8.78022L9 20.2499Z"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M12.75 6L18 11.25"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M20.2501 20.2501H9.00013L3.79785 15.0479"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const AddMsgIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.5 8H13.5"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M8 2.5V13.5"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const OnlineIcon = () => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="8"
                cy="8"
                r="7"
                fill="#23BD33"
                stroke="white"
                stroke-width="2"
            />
        </svg>
    );
};
export const PlusIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.5 8H13.5"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M8 2.5V13.5"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const MarkReadIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14 8C14 4.6875 11.3125 2 8 2C4.6875 2 2 4.6875 2 8C2 11.3125 4.6875 14 8 14C11.3125 14 14 11.3125 14 8Z"
                stroke="#1A1F36"
                stroke-width="1.5"
                stroke-miterlimit="10"
            />
            <path
                d="M11 5.50049L6.8 10.5005L5 8.50049"
                stroke="#1A1F36"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const AvtarIcon = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="32" height="32" rx="16" fill="#DDDEE1" />
            <path
                d="M14.0881 23.5005C14.0043 23.5006 13.9215 23.4823 13.8456 23.447C13.7696 23.4117 13.7023 23.3601 13.6484 23.296C13.5945 23.2319 13.5553 23.1567 13.5335 23.0758C13.5118 22.9949 13.508 22.9102 13.5224 22.8277V22.8243L14.4009 18.0005H10.9999C10.9055 18.0005 10.8131 17.9738 10.7332 17.9234C10.6534 17.8731 10.5894 17.8011 10.5488 17.7159C10.5081 17.6307 10.4924 17.5358 10.5034 17.442C10.5145 17.3483 10.5518 17.2596 10.6112 17.1862L17.4603 8.71928C17.5382 8.62032 17.6464 8.54962 17.7684 8.51798C17.8903 8.48635 18.0193 8.49553 18.1355 8.54411C18.2518 8.5927 18.3489 8.67802 18.412 8.78702C18.4752 8.89603 18.5009 9.02272 18.4853 9.14772C18.4853 9.1571 18.4828 9.16616 18.4812 9.17553L17.5996 14.0005H20.9999C21.0943 14.0005 21.1868 14.0273 21.2667 14.0776C21.3465 14.128 21.4105 14.1999 21.4511 14.2851C21.4918 14.3703 21.5075 14.4653 21.4965 14.559C21.4854 14.6528 21.4481 14.7415 21.3887 14.8149L14.5387 23.2818C14.4849 23.3498 14.4164 23.4048 14.3384 23.4427C14.2604 23.4805 14.1748 23.5003 14.0881 23.5005Z"
                fill="#515669"
            />
        </svg>
    );
};
export const UploadWhiteIcon = () => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.0625 8.18647L12 4.25L15.9375 8.18647"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M12 14.7502V4.25293"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M20.25 14.75V20C20.25 20.1989 20.171 20.3897 20.0303 20.5303C19.8897 20.671 19.6989 20.75 19.5 20.75H4.5C4.30109 20.75 4.11032 20.671 3.96967 20.5303C3.82902 20.3897 3.75 20.1989 3.75 20V14.75"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const CommentBlackIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.19421 13.1952C2.35557 11.7815 2.06187 10.1102 2.36826 8.49521C2.67466 6.88024 3.56007 5.43266 4.85823 4.42431C6.15639 3.41596 7.77801 2.91619 9.41858 3.01886C11.0591 3.12152 12.6058 3.81955 13.7681 4.98187C14.9305 6.1442 15.6285 7.69086 15.7312 9.33143C15.8338 10.972 15.3341 12.5936 14.3257 13.8918C13.3174 15.19 11.8698 16.0754 10.2549 16.3818C8.63989 16.6882 6.96862 16.3945 5.55486 15.5558L5.55488 15.5558L3.22356 16.2219C3.1271 16.2494 3.02504 16.2507 2.92793 16.2255C2.83082 16.2004 2.74221 16.1497 2.67128 16.0788C2.60035 16.0078 2.54967 15.9192 2.52451 15.8221C2.49935 15.725 2.50061 15.6229 2.52817 15.5265L3.19426 13.1952L3.19421 13.1952Z"
                stroke="#1D2026"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M8.63086 16.4899C8.96268 17.4319 9.49929 18.2886 10.202 18.9983C10.9048 19.708 11.7561 20.253 12.6948 20.594C13.6335 20.9351 14.6362 21.0637 15.6306 20.9706C16.625 20.8776 17.5864 20.5652 18.4455 20.0558L18.4455 20.0558L20.7768 20.7219C20.8732 20.7494 20.9753 20.7507 21.0724 20.7255C21.1695 20.7004 21.2581 20.6497 21.3291 20.5788C21.4 20.5078 21.4507 20.4192 21.4758 20.3221C21.501 20.225 21.4997 20.1229 21.4722 20.0265L20.8061 17.6952L20.8061 17.6952C21.398 16.6971 21.7226 15.5633 21.7486 14.4032C21.7747 13.2431 21.5013 12.0959 20.9549 11.0722C20.4085 10.0485 19.6075 9.18294 18.6291 8.55897C17.6508 7.935 16.5281 7.57371 15.3695 7.50995"
                stroke="#1D2026"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const CommentGrayIcon = ({ color }) => {
    return (
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.16184 10.996C2.46297 9.81785 2.21822 8.42512 2.47355 7.07931C2.72888 5.7335 3.46672 4.52719 4.54852 3.6869C5.63033 2.8466 6.98168 2.43013 8.34882 2.51568C9.71596 2.60124 11.0048 3.18293 11.9735 4.15153C12.9421 5.12013 13.5238 6.40902 13.6093 7.77616C13.6949 9.1433 13.2784 10.4946 12.4381 11.5765C11.5978 12.6583 10.3915 13.3961 9.04572 13.6514C7.69991 13.9068 6.30718 13.662 5.12905 12.9632L5.12907 12.9631L3.1863 13.5182C3.10592 13.5412 3.02086 13.5422 2.93994 13.5212C2.85902 13.5003 2.78518 13.458 2.72607 13.3989C2.66696 13.3398 2.62473 13.266 2.60376 13.1851C2.58279 13.1041 2.58384 13.0191 2.60681 12.9387L3.16189 10.9959L3.16184 10.996Z"
                stroke={color}
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M7.69141 13.7416C7.96793 14.5266 8.4151 15.2405 9.00071 15.8319C9.58633 16.4233 10.2958 16.8774 11.0781 17.1616C11.8603 17.4458 12.6959 17.553 13.5245 17.4755C14.3532 17.3979 15.1543 17.1376 15.8703 16.7132L15.8702 16.7131L17.813 17.2682C17.8934 17.2911 17.9784 17.2922 18.0594 17.2712C18.1403 17.2503 18.2141 17.208 18.2732 17.1489C18.3323 17.0898 18.3746 17.016 18.3955 16.935C18.4165 16.8541 18.4155 16.7691 18.3925 16.6887L17.8374 14.7459L17.8375 14.746C18.3307 13.9142 18.6012 12.9694 18.6229 12.0026C18.6446 11.0359 18.4168 10.0798 17.9614 9.22678C17.5061 8.37371 16.8386 7.6524 16.0233 7.13242C15.208 6.61245 14.2725 6.31137 13.3069 6.25824"
                stroke={color}
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const LoadingIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 3V6"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                opacity="0.9"
                d="M18.3635 5.63605L16.2422 7.75737"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                opacity="0.8"
                d="M21 12H18"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                opacity="0.7"
                d="M18.3635 18.3639L16.2422 16.2426"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                opacity="0.6"
                d="M12 21V18"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                opacity="0.5"
                d="M5.63672 18.3639L7.75804 16.2426"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                opacity="0.4"
                d="M3 12H6"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                opacity="0.3"
                d="M5.63672 5.63605L7.75804 7.75737"
                stroke="#1D83F8"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const DownloadIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 3.125V16.875"
                stroke="#007AFF"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M4.375 11.25L10 16.875L15.625 11.25"
                stroke="#007AFF"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
export const SkipBackButtonIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.16699 10.833C4.62723 10.833 4.99304 11.2089 5.06908 11.6628C5.46516 14.0272 7.52464 15.833 10.0003 15.833C12.7587 15.833 15.0003 13.5913 15.0003 10.833C15.0003 8.40663 13.2657 6.38004 10.9707 5.9274C10.4417 5.82306 10.0003 6.27012 10.0003 6.80932C10.0003 7.67912 8.9487 8.11472 8.33366 7.49967L6.54076 5.70678C6.15024 5.31626 6.15024 4.68309 6.54076 4.29257L8.33366 2.49967C8.9487 1.88463 10.0003 2.32023 10.0003 3.19003C10.0003 3.72923 10.44 4.15883 10.9735 4.23678C14.1951 4.70749 16.667 7.48026 16.667 10.833C16.667 14.5163 13.6837 17.4997 10.0003 17.4997C6.59865 17.4997 3.79402 14.9552 3.38497 11.6647C3.3282 11.208 3.70675 10.833 4.16699 10.833Z"
                fill="white"
            />
            <path
                d="M8.9416 13.2833V9.72496H8.8666L7.3916 10.25V10.825L8.23327 10.5666V13.2833H8.9416ZM10.0999 11.2V11.8166C10.0999 13.4 11.1916 13.3333 11.2999 13.3333C11.4166 13.3333 12.4999 13.4083 12.4999 11.8166V11.2C12.4999 9.61663 11.4083 9.6833 11.2999 9.6833C11.1833 9.6833 10.0999 9.6083 10.0999 11.2ZM11.7999 11.1V11.9083C11.7999 12.55 11.6249 12.7666 11.3083 12.7666C10.9916 12.7666 10.8083 12.55 10.8083 11.9083V11.1C10.8083 10.475 10.9916 10.2583 11.2999 10.2583C11.6166 10.25 11.7999 10.475 11.7999 11.1Z"
                fill="white"
            />
        </svg>
    );
};
export const SkipForwardButtonIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.833 10.833C15.3728 10.833 15.007 11.2089 14.9309 11.6628C14.5348 14.0272 12.4754 15.833 9.99967 15.833C7.24134 15.833 4.99967 13.5913 4.99967 10.833C4.99967 8.40663 6.73425 6.38004 9.02926 5.9274C9.55827 5.82306 9.99967 6.27012 9.99967 6.80932C9.99967 7.67912 11.0513 8.11472 11.6663 7.49967L13.4592 5.70678C13.8498 5.31626 13.8498 4.68309 13.4592 4.29257L11.6663 2.49967C11.0513 1.88463 9.99967 2.32023 9.99967 3.19003C9.99967 3.72923 9.56003 4.15883 9.0265 4.23678C5.80486 4.70749 3.33301 7.48026 3.33301 10.833C3.33301 14.5163 6.31634 17.4997 9.99967 17.4997C13.4013 17.4997 16.206 14.9552 16.615 11.6647C16.6718 11.208 16.2932 10.833 15.833 10.833Z"
                fill="white"
            />
            <path
                d="M9.05 13.2833V9.72496H8.975L7.5 10.25V10.825L8.34167 10.5666V13.2833H9.05ZM10.2083 11.2V11.8166C10.2083 13.4 11.3 13.3333 11.4083 13.3333C11.525 13.3333 12.6083 13.4083 12.6083 11.8166V11.2C12.6083 9.61663 11.5167 9.6833 11.4083 9.6833C11.2917 9.6833 10.2083 9.6083 10.2083 11.2ZM11.9083 11.1V11.9083C11.9083 12.55 11.7333 12.7666 11.4167 12.7666C11.1 12.7666 10.9167 12.55 10.9167 11.9083V11.1C10.9167 10.475 11.1 10.2583 11.4083 10.2583C11.725 10.25 11.9083 10.475 11.9083 11.1Z"
                fill="white"
            />
        </svg>
    );
};
export const DocumentWhiteIcon = () => {
    return (
        <svg
            width="16"
            height="18"
            viewBox="0 0 16 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.66667 10.6676C4.43056 10.6676 4.2325 10.5876 4.0725 10.4276C3.91306 10.2682 3.83333 10.0704 3.83333 9.83427C3.83333 9.59816 3.91306 9.4001 4.0725 9.2401C4.2325 9.08066 4.43056 9.00093 4.66667 9.00093H11.3333C11.5694 9.00093 11.7672 9.08066 11.9267 9.2401C12.0867 9.4001 12.1667 9.59816 12.1667 9.83427C12.1667 10.0704 12.0867 10.2682 11.9267 10.4276C11.7672 10.5876 11.5694 10.6676 11.3333 10.6676H4.66667ZM4.66667 14.0009C4.43056 14.0009 4.2325 13.9209 4.0725 13.7609C3.91306 13.6015 3.83333 13.4037 3.83333 13.1676C3.83333 12.9315 3.91306 12.7337 4.0725 12.5743C4.2325 12.4143 4.43056 12.3343 4.66667 12.3343H8.83333C9.06944 12.3343 9.2675 12.4143 9.4275 12.5743C9.58694 12.7337 9.66667 12.9315 9.66667 13.1676C9.66667 13.4037 9.58694 13.6015 9.4275 13.7609C9.2675 13.9209 9.06944 14.0009 8.83333 14.0009H4.66667ZM2.16667 17.3343C1.70833 17.3343 1.31583 17.1712 0.989167 16.8451C0.663055 16.5184 0.5 16.1259 0.5 15.6676V4.00094C0.5 3.5426 0.663055 3.15038 0.989167 2.82427C1.31583 2.4976 1.70833 2.33427 2.16667 2.33427H3V1.50094C3 1.26482 3.07972 1.06677 3.23917 0.906769C3.39917 0.747325 3.59722 0.667603 3.83333 0.667603C4.06944 0.667603 4.2675 0.747325 4.4275 0.906769C4.58694 1.06677 4.66667 1.26482 4.66667 1.50094V2.33427H11.3333V1.50094C11.3333 1.26482 11.4133 1.06677 11.5733 0.906769C11.7328 0.747325 11.9306 0.667603 12.1667 0.667603C12.4028 0.667603 12.6006 0.747325 12.76 0.906769C12.92 1.06677 13 1.26482 13 1.50094V2.33427H13.8333C14.2917 2.33427 14.6842 2.4976 15.0108 2.82427C15.3369 3.15038 15.5 3.5426 15.5 4.00094V15.6676C15.5 16.1259 15.3369 16.5184 15.0108 16.8451C14.6842 17.1712 14.2917 17.3343 13.8333 17.3343H2.16667ZM2.16667 15.6676H13.8333V7.33427H2.16667V15.6676ZM2.16667 5.6676H13.8333V4.00094H2.16667V5.6676Z"
                fill="white"
            />
        </svg>
    );
};
export const SettingIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M16.1663 12.5007C16.0554 12.752 16.0223 13.0308 16.0713 13.3011C16.1204 13.5715 16.2492 13.8209 16.4413 14.0173L16.4913 14.0673C16.6463 14.2221 16.7692 14.4059 16.8531 14.6083C16.937 14.8106 16.9802 15.0275 16.9802 15.2465C16.9802 15.4655 16.937 15.6824 16.8531 15.8847C16.7692 16.0871 16.6463 16.2709 16.4913 16.4257C16.3366 16.5806 16.1527 16.7035 15.9504 16.7874C15.7481 16.8713 15.5312 16.9145 15.3122 16.9145C15.0932 16.9145 14.8763 16.8713 14.6739 16.7874C14.4716 16.7035 14.2878 16.5806 14.133 16.4257L14.083 16.3757C13.8866 16.1835 13.6372 16.0547 13.3668 16.0056C13.0965 15.9566 12.8177 15.9897 12.5663 16.1007C12.3199 16.2063 12.1097 16.3817 11.9616 16.6053C11.8135 16.8288 11.7341 17.0908 11.733 17.359V17.5007C11.733 17.9427 11.5574 18.3666 11.2449 18.6792C10.9323 18.9917 10.5084 19.1673 10.0663 19.1673C9.62431 19.1673 9.20039 18.9917 8.88783 18.6792C8.57527 18.3666 8.39968 17.9427 8.39968 17.5007V17.4257C8.39322 17.1498 8.30394 16.8823 8.14343 16.6579C7.98293 16.4335 7.75862 16.2626 7.49968 16.1673C7.24833 16.0564 6.96951 16.0233 6.69918 16.0723C6.42886 16.1213 6.17941 16.2502 5.98301 16.4423L5.93301 16.4923C5.77822 16.6473 5.59441 16.7702 5.39208 16.8541C5.18975 16.938 4.97287 16.9811 4.75384 16.9811C4.53482 16.9811 4.31794 16.938 4.11561 16.8541C3.91328 16.7702 3.72946 16.6473 3.57467 16.4923C3.41971 16.3375 3.29678 16.1537 3.21291 15.9514C3.12903 15.7491 3.08586 15.5322 3.08586 15.3132C3.08586 15.0941 3.12903 14.8772 3.21291 14.6749C3.29678 14.4726 3.41971 14.2888 3.57467 14.134L3.62467 14.084C3.81679 13.8876 3.94566 13.6381 3.99468 13.3678C4.04369 13.0975 4.0106 12.8187 3.89967 12.5673C3.79404 12.3208 3.61864 12.1106 3.39506 11.9626C3.17149 11.8145 2.9095 11.7351 2.64134 11.734H2.49967C2.05765 11.734 1.63372 11.5584 1.32116 11.2458C1.0086 10.9333 0.833008 10.5093 0.833008 10.0673C0.833008 9.62529 1.0086 9.20137 1.32116 8.88881C1.63372 8.57625 2.05765 8.40065 2.49967 8.40065H2.57467C2.8505 8.3942 3.11801 8.30492 3.34242 8.14441C3.56684 7.9839 3.73777 7.7596 3.83301 7.50065C3.94394 7.24931 3.97703 6.97049 3.92801 6.70016C3.879 6.42983 3.75012 6.18038 3.55801 5.98398L3.50801 5.93398C3.35305 5.7792 3.23012 5.59538 3.14624 5.39305C3.06237 5.19072 3.0192 4.97384 3.0192 4.75482C3.0192 4.53579 3.06237 4.31891 3.14624 4.11658C3.23012 3.91425 3.35305 3.73044 3.50801 3.57565C3.6628 3.42069 3.84661 3.29776 4.04894 3.21389C4.25127 3.13001 4.46815 3.08684 4.68717 3.08684C4.9062 3.08684 5.12308 3.13001 5.32541 3.21389C5.52774 3.29776 5.71155 3.42069 5.86634 3.57565L5.91634 3.62565C6.11274 3.81777 6.36219 3.94664 6.63252 3.99566C6.90285 4.04467 7.18166 4.01158 7.43301 3.90065H7.49968C7.74615 3.79502 7.95636 3.61961 8.10442 3.39604C8.25248 3.17246 8.33194 2.91047 8.33301 2.64232V2.50065C8.33301 2.05862 8.5086 1.6347 8.82116 1.32214C9.13373 1.00958 9.55765 0.833984 9.99968 0.833984C10.4417 0.833984 10.8656 1.00958 11.1782 1.32214C11.4907 1.6347 11.6663 2.05862 11.6663 2.50065V2.57565C11.6674 2.84381 11.7469 3.1058 11.8949 3.32937C12.043 3.55295 12.2532 3.72835 12.4997 3.83398C12.751 3.94491 13.0298 3.978 13.3002 3.92899C13.5705 3.87997 13.8199 3.7511 14.0163 3.55898L14.0663 3.50898C14.2211 3.35402 14.4049 3.23109 14.6073 3.14722C14.8096 3.06334 15.0265 3.02017 15.2455 3.02017C15.4645 3.02017 15.6814 3.06334 15.8837 3.14722C16.0861 3.23109 16.2699 3.35402 16.4247 3.50898C16.5796 3.66377 16.7026 3.84759 16.7864 4.04992C16.8703 4.25225 16.9135 4.46913 16.9135 4.68815C16.9135 4.90718 16.8703 5.12406 16.7864 5.32639C16.7026 5.52872 16.5796 5.71253 16.4247 5.86732L16.3747 5.91732C16.1826 6.11372 16.0537 6.36317 16.0047 6.63349C15.9557 6.90382 15.9887 7.18264 16.0997 7.43399V7.50065C16.2053 7.74713 16.3807 7.95733 16.6043 8.1054C16.8279 8.25346 17.0899 8.33292 17.358 8.33399H17.4997C17.9417 8.33399 18.3656 8.50958 18.6782 8.82214C18.9907 9.1347 19.1663 9.55862 19.1663 10.0007C19.1663 10.4427 18.9907 10.8666 18.6782 11.1792C18.3656 11.4917 17.9417 11.6673 17.4997 11.6673H17.4247C17.1565 11.6684 16.8945 11.7478 16.671 11.8959C16.4474 12.044 16.272 12.2542 16.1663 12.5007V12.5007Z"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export const VideoButtonIcon = () => {
    return (
        <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="30.02" cy="30.02" r="30.02" fill="#1D83F8" />
            <path d="M41.3479 29.976L26.0547 38.8056L26.0547 21.1465L41.3479 29.976Z" fill="white" />
        </svg>


    );
};

export const FormSubMissionButton = () => {
    return (
        <svg width="45" height="46" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.958984" y="0.979187" width="44.0416" height="44.0416" rx="22.0208" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8483 26.5202C18.6408 26.3127 18.6408 25.9763 18.8483 25.7689L25.4544 19.1628L19.9753 19.1628C19.6819 19.1628 19.444 18.9249 19.444 18.6315C19.444 18.3381 19.6819 18.1003 19.9753 18.1003L26.737 18.1003C27.0304 18.1003 27.2682 18.3381 27.2682 18.6315L27.2682 25.3932C27.2682 25.6866 27.0304 25.9245 26.737 25.9245C26.4436 25.9245 26.2057 25.6866 26.2057 25.3932V19.9141L19.5996 26.5202C19.3921 26.7276 19.0558 26.7276 18.8483 26.5202Z" fill="#1D83F8" />
        </svg>

    )
}

export const KingsterLogo = () => {
    return (
        <svg width="209" height="89" viewBox="0 0 299 89" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M79.3925 78.5949C79.3925 80.7151 77.0806 82.0469 75.2171 81.0001L48.3668 65.9168C47.5109 65.436 46.4625 65.436 45.6066 65.9168L18.7563 81.0001C16.8928 82.0469 14.5809 80.7151 14.5809 78.5949L14.5809 68.6825C14.5809 67.6872 15.1214 66.7686 15.9963 66.2773L45.6068 49.6466C46.4626 49.166 47.5108 49.166 48.3666 49.6466L77.9771 66.2773C78.852 66.7686 79.3925 67.6872 79.3925 68.6825V78.5949Z" fill="white" />
            <path d="M60.193 0.37457C62.0484 -0.685354 64.3698 0.629204 64.3858 2.74899L64.6178 33.2984C64.6252 34.2716 65.1491 35.1694 65.9973 35.6624L92.6205 51.1358C94.4679 52.2095 94.4578 54.8559 92.6023 55.9158L83.9333 60.868C83.0618 61.3658 81.9872 61.3617 81.1196 60.8574L51.7642 43.7927C50.9162 43.2998 50.3924 42.4022 50.385 41.4291L50.1263 7.74297C50.1187 6.74738 50.6525 5.82455 51.5239 5.32675L60.193 0.37457Z" fill="white" />
            <path d="M1.39765 55.9228C-0.457805 54.8629 -0.467858 52.2166 1.3795 51.1429L28.0028 35.6694C28.8509 35.1764 29.3748 34.2787 29.3822 33.3054L29.6141 2.75602C29.6302 0.636235 31.9516 -0.678323 33.807 0.381601L42.4761 5.33378C43.3475 5.83159 43.8813 6.75441 43.8737 7.75L43.615 41.4361C43.6076 42.4092 43.0838 43.3068 42.2358 43.7997L12.8804 60.8644C12.0128 61.3688 10.9382 61.3728 10.0667 60.875L1.39765 55.9228Z" fill="white" />
            <path d="M64.1298 86.2302C64.1298 88.3496 61.8193 89.6815 59.9558 88.6362L48.4121 82.1608C47.5569 81.6811 46.51 81.6811 45.6548 82.1608L34.1111 88.6362C32.2476 89.6815 29.9371 88.3496 29.9371 86.2302V84.016C29.9371 83.0201 30.4783 82.101 31.354 81.6099L45.655 73.5894C46.5101 73.1099 47.5568 73.1099 48.4119 73.5894L62.7129 81.6099C63.5886 82.101 64.1298 83.0201 64.1298 84.016V86.2302Z" fill="white" />
            <path d="M74.5043 9.66527C76.3594 8.6055 78.6805 9.91952 78.6971 12.039L78.8005 25.2C78.8081 26.1727 79.3317 27.07 80.1793 27.5629L91.6471 34.2319C93.4939 35.3059 93.4835 37.9517 91.6284 39.0115L89.677 40.1262C88.8054 40.6241 87.7304 40.62 86.8628 40.1153L72.6633 31.8561C71.8159 31.3632 71.2924 30.4661 71.2847 29.4935L71.1554 13.1969C71.1475 12.201 71.6813 11.2779 72.5529 10.78L74.5043 9.66527Z" fill="white" />
            <path d="M2.36594 39.0133C0.510761 37.9535 0.500372 35.3077 2.34718 34.2337L13.815 27.5646C14.6626 27.0717 15.1862 26.1745 15.1938 25.2017L15.2972 12.0407C15.3138 9.92127 17.6349 8.60726 19.49 9.66702L21.4414 10.7817C22.313 11.2797 22.8468 12.2028 22.8389 13.1986L22.7096 29.4953C22.7019 30.4679 22.1784 31.365 21.331 31.8579L7.13154 40.117C6.26386 40.6217 5.18894 40.6259 4.31728 40.128L2.36594 39.0133Z" fill="white" />
            <path d="M121.701 18.2479V22.7582C121.701 23.9782 121.923 24.1261 122.366 24.1261C123.143 24.1261 124.695 22.6843 125.324 21.9818C127.283 19.8006 129.427 17.5085 130.61 15.7709C130.943 15.2903 131.091 14.9576 131.091 14.8097C131.091 14.6618 130.943 14.403 130.463 14.3291L129.169 14.1073C128.762 13.8485 128.836 12.9612 129.316 12.8133C131.202 12.8873 132.57 12.9242 133.901 12.9242C135.269 12.9242 136.895 12.8873 138.374 12.8133C138.818 12.9612 138.855 13.8115 138.559 14.1073C137.265 14.2552 136.156 14.44 135.379 14.7727C133.901 15.3642 132.311 16.7691 129.908 19.5049L128.207 21.4273C127.838 21.834 127.727 22.1297 127.727 22.2776C127.727 22.4624 127.949 22.9061 129.058 24.5697C130.906 27.3425 133.087 30.8915 135.601 34.2188C136.6 35.5497 137.302 35.8085 138.337 35.9564L139.52 36.1413C139.742 36.474 139.742 37.2503 139.409 37.4352C137.561 37.3613 135.786 37.3243 134.086 37.3243C132.2 37.3243 130.352 37.3613 128.281 37.4352C127.801 37.2873 127.801 36.3631 128.207 36.1413L129.132 35.9194C129.538 35.8085 129.76 35.6976 129.76 35.5497C129.76 35.4019 129.686 35.1431 129.464 34.8103L127.32 31.52L125.361 28.5255C124.03 26.4921 123.401 25.6049 122.588 25.6049C121.738 25.6049 121.701 26.1224 121.701 28.1188V32.0006C121.701 35.4388 121.923 35.7716 123.586 35.9934L124.621 36.1413C124.917 36.4 124.917 37.2134 124.621 37.4352C122.662 37.3613 120.813 37.3243 119.039 37.3243C117.375 37.3243 115.453 37.3613 113.493 37.4352C113.198 37.2134 113.198 36.3631 113.493 36.1413L114.529 35.9934C116.192 35.7716 116.414 35.4388 116.414 32.0006V18.2479C116.414 14.8097 116.192 14.477 114.529 14.2552L113.493 14.1073C113.087 13.8855 113.087 13.0352 113.493 12.8133C115.342 12.8873 117.19 12.9242 119.039 12.9242C120.813 12.9242 122.662 12.8873 124.621 12.8133C124.954 13.0352 124.954 13.8855 124.621 14.1073L123.586 14.2552C121.923 14.477 121.701 14.8097 121.701 18.2479Z" fill="white" />
            <path d="M149.535 18.3218V31.9267C149.535 35.4019 149.757 35.6606 151.457 35.9564L152.492 36.1413C152.788 36.3631 152.751 37.2134 152.455 37.4352C150.459 37.3613 148.647 37.3243 146.91 37.3243C145.135 37.3243 143.287 37.3613 141.291 37.4352C140.995 37.2134 140.995 36.3631 141.291 36.1413L142.326 35.9564C144.026 35.6606 144.248 35.4019 144.248 31.9267V18.3218C144.248 14.8467 144.026 14.5879 142.326 14.2921L141.291 14.1073C140.995 13.8855 140.995 13.0352 141.291 12.8133C143.287 12.8873 145.135 12.9242 146.91 12.9242C148.647 12.9242 150.496 12.8873 152.492 12.8133C152.788 13.0352 152.788 13.8855 152.492 14.1073L151.457 14.2921C149.757 14.5879 149.535 14.8467 149.535 18.3218Z" fill="white" />
            <path d="M177.857 22.2037V31.0394C177.857 33.4425 177.857 35.7716 177.931 36.9916C177.672 37.4352 175.231 37.8419 174.343 37.8419C174.306 37.8419 174.493 35.9564 172.755 33.8122L164.215 23.2388C162.071 20.614 160.851 19.0612 160.186 18.5067C160.001 18.8764 160.001 19.5049 160.001 20.8727V28.0449C160.001 31.0394 160.149 33.8122 160.555 34.8103C160.888 35.5867 161.738 35.8455 162.699 35.9934L163.735 36.1413C164.03 36.437 163.956 37.2134 163.735 37.4352C161.738 37.3613 160.259 37.3243 158.781 37.3243C157.413 37.3243 156.045 37.3613 154.64 37.4352C154.418 37.2134 154.344 36.437 154.64 36.1413L155.269 36.0303C156.267 35.8455 157.006 35.5867 157.302 34.8103C157.709 33.8122 157.819 31.0394 157.819 28.0449V18.6546C157.819 16.6212 157.782 16.0297 157.561 15.5121C157.265 14.8836 156.747 14.44 155.453 14.2552L154.418 14.1073C154.159 13.8115 154.196 12.9242 154.566 12.8133C156.304 12.8873 158.152 12.9242 159.668 12.9242C160.925 12.9242 161.997 12.8873 162.773 12.8133C163.143 14.477 165.546 17.2867 168.873 21.2424L171.979 24.9024C173.606 26.8249 174.678 28.1188 175.528 28.9691C175.676 28.5994 175.676 27.9709 175.676 27.3055V22.2037C175.676 19.2091 175.528 16.4364 175.121 15.4382C174.789 14.6618 173.975 14.403 172.977 14.2552L171.979 14.1073C171.683 13.8115 171.757 13.0352 171.979 12.8133C173.975 12.8873 175.417 12.9242 176.933 12.9242C178.301 12.9242 179.632 12.8873 181.073 12.8133C181.295 13.0352 181.369 13.8115 181.073 14.1073L180.408 14.2182C179.447 14.3661 178.744 14.6618 178.412 15.4382C178.005 16.4364 177.857 19.2091 177.857 22.2037Z" fill="white" />
            <path d="M205.919 31.0764V33.1467C205.919 34.6994 205.993 35.4388 206.695 35.5867C206.843 35.7346 206.806 36.3631 206.584 36.474C205.956 36.5849 204.995 36.6958 203.996 37.0285C202.702 37.4352 198.117 37.9158 196.046 37.9158C193.532 37.9158 192.795 37.657 190.17 36.6219C185.844 34.8843 182.887 30.7806 182.887 25.457C182.887 20.8358 184.957 16.7691 189.393 14.2921C191.907 12.9242 194.902 12.3327 198.044 12.3327C202.148 12.3327 204.181 13.22 205.364 13.22C205.475 14.3291 205.512 16.917 205.882 19.1721C205.734 19.5788 204.736 19.6158 204.477 19.2461C203.294 15.7709 200.965 14.0333 197.527 14.0333C191.649 14.0333 188.802 18.9133 188.802 24.7546C188.802 30.0412 190.613 33.1837 193.016 34.8103C194.791 35.9934 196.713 36.2152 198.081 36.2152C200.189 36.2152 200.632 35.8085 200.632 33.4055V31.0764C200.632 29.08 200.41 28.8582 198.636 28.5994L197.009 28.3776C196.602 28.1558 196.602 27.3055 197.009 27.0837C199.634 27.1576 201.445 27.1946 203.257 27.1946C205.032 27.1946 206.843 27.1576 208.1 27.0837C208.396 27.3055 208.396 28.1558 208.1 28.3776L207.25 28.5255C206.141 28.7103 205.919 29.08 205.919 31.0764Z" fill="white" />
            <path d="M226.192 30.4109C226.192 34.9582 221.052 37.9158 215.469 37.9158C212.068 37.9158 211.367 36.9546 210.591 36.5109C209.888 35.6976 209.408 33.0358 209.408 30.5218C209.667 30.0412 210.517 30.0043 210.813 30.4109C211.552 32.814 214.029 36.2152 217.172 36.2152C219.907 36.2152 221.164 34.3297 221.164 32.4812C221.164 29.4867 218.355 27.7121 216.136 26.6031C213.475 25.2721 210.554 23.054 210.554 19.394C210.517 15.2164 213.77 12.3327 219.131 12.3327C220.351 12.3327 221.867 12.4806 223.345 12.9242C223.826 13.0721 224.159 13.1461 224.602 13.22C224.898 14.0333 225.268 16.0297 225.268 18.5067C225.083 18.9503 224.159 18.9873 223.826 18.6176C223.198 16.7321 221.608 14.0333 218.946 14.0333C216.506 14.0333 215.175 15.623 215.175 17.4715C215.175 19.1721 216.691 20.7249 218.539 21.6861L220.979 22.98C223.272 24.2 226.192 26.3443 226.192 30.4109Z" fill="white" />
            <path d="M236.686 32.0006V15.697C236.686 14.8097 236.686 14.6249 235.799 14.6249H233.507C230.808 14.6249 230.032 16.1036 228.923 18.8024C228.479 19.0243 227.777 18.9503 227.555 18.4697C228.331 15.9188 228.516 13.6267 228.775 12.1849C228.923 12.0739 229.108 12 229.292 12C229.477 12 229.662 12.037 229.81 12.1479C229.995 12.7764 230.106 12.9242 232.915 12.9242H246.668C249.108 12.9242 249.663 12.8873 249.995 12.1109C250.143 12.037 250.254 12 250.476 12C250.698 12 250.957 12.1479 251.031 12.2588C250.661 13.5158 250.402 16.5103 250.476 18.6176C250.291 18.9503 249.293 19.0243 249.108 18.7285C248.48 16.3624 247.962 14.6249 245.189 14.6249H242.971C242.084 14.6249 241.973 14.7358 241.973 15.697V32.0006C241.973 35.4388 242.195 35.7346 243.858 35.9564L245.337 36.1413C245.596 36.3631 245.596 37.2134 245.337 37.4352C242.934 37.3613 241.086 37.3243 239.422 37.3243C237.648 37.3243 235.725 37.3613 233.137 37.4352C232.841 37.2134 232.841 36.3631 233.137 36.1413L234.801 35.9564C236.465 35.7716 236.686 35.4388 236.686 32.0006Z" fill="white" />
            <path d="M260.588 16.0667V22.5364C260.588 23.5715 260.625 23.6455 261.624 23.6455H264.175C266.097 23.6455 266.541 23.3867 266.91 21.6121L267.095 20.6879C267.354 20.3921 268.278 20.3921 268.463 20.7249C268.389 21.9079 268.352 23.2388 268.352 24.6437C268.352 26.0485 268.389 27.3794 268.463 28.5624C268.278 28.8952 267.354 28.9321 267.095 28.5994L266.91 27.6752C266.541 25.9006 266.097 25.6049 264.175 25.6049H261.624C260.625 25.6049 260.588 25.6418 260.588 26.7509V31.1503C260.588 32.8509 260.736 34.034 261.18 34.6625C261.661 35.3279 262.363 35.6237 265.062 35.6237C268.278 35.6237 269.535 35.5128 271.568 31.3352C271.864 30.9285 272.788 31.0764 272.936 31.52C272.788 33.4425 271.901 36.437 271.384 37.4352C269.424 37.3613 265.875 37.3243 262.844 37.3243H258.038C256.263 37.3243 254.451 37.3613 251.679 37.4352C251.383 37.2134 251.383 36.3261 251.679 36.1413L253.416 35.8825C255.08 35.6237 255.302 35.4019 255.302 32.0006V18.2109C255.302 14.8467 255.08 14.6249 253.416 14.2921L252.492 14.1073C252.159 13.8855 252.196 13.0352 252.566 12.8133C254.304 12.8873 256.115 12.9242 257.89 12.9242H265.727C268.093 12.9242 270.201 12.8873 270.681 12.8133C270.718 13.4049 270.977 16.0667 271.162 18.5436C271.014 18.9503 270.164 19.0243 269.794 18.6915C269.387 17.3976 268.87 16.2885 268.389 15.7709C267.687 15.0685 266.578 14.6249 264.766 14.6249H261.808C260.588 14.6249 260.588 14.6988 260.588 16.0667Z" fill="white" />
            <path d="M277.216 32.0006V18.9133C277.216 15.2164 277.143 14.8097 275.59 14.5879L274.592 14.44C274.222 14.2552 274.222 13.3309 274.666 13.1461C277.438 12.9612 280.322 12.8133 283.834 12.8133C286.976 12.8133 289.675 13.2939 291.08 14.1442C293.224 15.4012 294.333 17.2497 294.333 19.6158C294.333 22.9061 292.115 24.3109 290.415 25.1612C290.045 25.3461 290.045 25.5679 290.23 25.9746C292.67 30.9285 294.186 33.7012 295.96 35.217C296.921 35.9934 297.883 36.2152 298.437 36.2522C298.77 36.437 298.77 36.9916 298.585 37.2134C297.993 37.4722 296.81 37.5461 295.664 37.5461C292.263 37.5461 290.119 36.3261 288.492 33.6643C287.309 31.7049 286.459 29.8934 285.609 27.934C285.165 26.9358 284.573 26.64 283.649 26.64C282.355 26.64 282.281 26.714 282.281 27.4534V32.0006C282.281 35.4019 282.503 35.6606 284.167 35.9564L285.165 36.1413C285.424 36.3261 285.424 37.2134 285.165 37.4352C283.206 37.3613 281.505 37.3243 279.73 37.3243C277.882 37.3243 276.255 37.3613 274.333 37.4352C274.037 37.2134 274.037 36.3261 274.333 36.1413L275.331 35.9564C276.995 35.6606 277.216 35.4019 277.216 32.0006ZM282.281 16.3994V23.6085C282.281 24.9024 282.392 25.0134 284.573 25.0134C285.904 25.0134 286.681 24.6806 287.383 23.9782C288.012 23.3497 288.714 22.1667 288.714 19.9855C288.714 16.6582 286.755 14.5139 283.871 14.5139C282.355 14.5139 282.281 14.6249 282.281 16.3994Z" fill="white" />
            <path d="M116.198 70.8143V59.568C116.198 56.3191 116.136 55.8506 114.293 55.6319L113.793 55.5694C113.605 55.4444 113.668 54.8821 113.855 54.7884C115.198 54.8509 116.261 54.8821 117.541 54.8821H123.414C125.414 54.8821 127.257 54.8821 127.632 54.7884C127.819 55.3195 128.007 57.5687 128.132 58.9433C128.007 59.1307 127.507 59.1932 127.351 59.0057C126.882 57.5375 126.601 56.4441 124.976 56.038C124.32 55.8818 123.321 55.8506 121.946 55.8506H119.697C118.76 55.8506 118.76 55.913 118.76 57.1001V63.348C118.76 64.2227 118.853 64.2227 119.791 64.2227H121.603C122.915 64.2227 123.883 64.1602 124.258 64.0353C124.633 63.9103 124.851 63.7229 125.008 62.9419L125.258 61.6611C125.414 61.4737 125.945 61.4737 126.07 61.6923C126.07 62.4421 125.945 63.6604 125.945 64.8475C125.945 65.9721 126.07 67.1592 126.07 67.8465C125.945 68.0652 125.414 68.0652 125.258 67.8777L124.976 66.6594C124.851 66.0971 124.633 65.6285 124.008 65.4723C123.571 65.3473 122.821 65.3161 121.603 65.3161H119.791C118.853 65.3161 118.76 65.3473 118.76 66.1596V70.5643C118.76 72.22 118.853 73.2822 119.353 73.8132C119.728 74.1881 120.384 74.5317 123.133 74.5317C125.539 74.5317 126.445 74.4068 127.132 74.0632C127.694 73.7508 128.538 72.6574 129.35 71.0329C129.569 70.8767 130.006 70.9705 130.131 71.2516C129.912 72.345 129.131 74.7504 128.725 75.5939C125.914 75.5314 123.133 75.5002 120.353 75.5002H117.541C116.198 75.5002 115.136 75.5314 113.293 75.5939C113.105 75.5002 113.043 75.0003 113.23 74.8129L114.261 74.7192C116.042 74.563 116.198 74.0944 116.198 70.8143Z" fill="white" />
            <path d="M134.441 70.8143V58.9433C134.441 56.7565 134.285 56.1005 132.973 55.913L132.286 55.8193C132.036 55.6631 132.005 55.1633 132.317 55.0383C134.973 54.8821 137.503 54.7884 140.158 54.7884C142.782 54.7884 145 54.9759 147.031 55.7256C151.248 57.2563 153.373 60.8176 153.373 64.9412C153.373 68.9086 151.467 72.3137 147.906 74.2506C145.875 75.344 143.313 75.7501 140.908 75.7501C138.909 75.7501 136.909 75.5002 135.816 75.5002C134.504 75.5002 133.379 75.5314 131.911 75.5939C131.724 75.5002 131.661 75.0003 131.849 74.8129L132.567 74.7192C134.379 74.4693 134.441 74.0944 134.441 70.8143ZM137.003 58.5684V70.0957C137.003 71.7514 137.097 72.7511 137.628 73.5008C138.315 74.4693 139.502 74.7817 141.47 74.7817C147.531 74.7817 150.249 70.8142 150.249 65.0037C150.249 61.5674 148.593 55.7568 140.408 55.7568C138.565 55.7568 137.565 56.0068 137.315 56.1942C137.066 56.3816 137.003 57.1626 137.003 58.5684Z" fill="white" />
            <path d="M173.718 66.3158V62.7232C173.718 60.7864 173.655 57.1938 173.124 56.2567C172.906 55.8818 172.343 55.6631 171.562 55.6006L170.781 55.5382C170.594 55.3195 170.657 54.9134 170.844 54.7884C172.031 54.8509 173.187 54.8821 174.405 54.8821C175.717 54.8821 176.561 54.8509 177.685 54.7884C177.935 54.9446 177.904 55.3507 177.748 55.5382L176.998 55.6006C176.217 55.6631 175.624 55.9443 175.436 56.3504C174.999 57.3813 174.999 60.9738 174.999 62.7232V66.2533C174.999 68.9711 174.561 71.8452 172.812 73.7195C171.469 75.1878 169.157 76 166.845 76C164.69 76 162.534 75.5939 161.004 74.2818C159.348 72.9073 158.567 70.6268 158.567 66.9093V59.5368C158.567 56.2879 158.504 55.7568 156.692 55.6006L155.911 55.5382C155.724 55.4132 155.787 54.8821 155.974 54.7884C157.536 54.8509 158.598 54.8821 159.848 54.8821C161.128 54.8821 162.159 54.8509 163.69 54.7884C163.878 54.8821 163.94 55.4132 163.753 55.5382L163.003 55.6006C161.191 55.7568 161.128 56.2879 161.128 59.5368V66.2845C161.128 71.3141 162.69 74.6255 167.47 74.6255C172 74.6255 173.718 71.0642 173.718 66.3158Z" fill="white" />
            <path d="M179.5 65.3161C179.5 61.8485 181.062 58.8808 183.436 57.0377C185.717 55.257 188.622 54.3823 191.871 54.3823C193.558 54.3823 195.932 54.7259 197.4 55.132C197.775 55.2258 197.994 55.2882 198.275 55.257C198.306 55.9755 198.463 57.9436 198.712 59.8492C198.556 60.0679 198.088 60.0991 197.869 59.9117C197.4 57.7874 195.995 55.3507 191.465 55.3507C186.685 55.3507 182.624 58.3809 182.624 64.8475C182.624 71.4078 186.779 75.0316 191.902 75.0316C195.932 75.0316 197.713 72.4075 198.431 70.5643C198.65 70.4081 199.119 70.4706 199.244 70.6893C199.025 72.3137 198.213 74.3755 197.744 74.9691C197.369 75.0316 196.994 75.1565 196.651 75.2815C195.963 75.5314 193.714 76 191.715 76C188.903 76 186.217 75.4377 183.936 73.907C181.437 72.1888 179.5 69.346 179.5 65.3161Z" fill="white" />
            <path d="M213.966 72.5012L212.592 68.2526C212.373 67.5653 212.248 67.4716 211.311 67.4716H206.594C205.813 67.4716 205.625 67.5653 205.407 68.2214L204.313 71.5015C203.845 72.9073 203.626 73.7508 203.626 74.0944C203.626 74.4693 203.782 74.6567 204.532 74.7192L205.563 74.8129C205.782 74.9691 205.782 75.4689 205.5 75.5939C204.688 75.5314 203.72 75.5314 202.252 75.5002C201.221 75.5002 200.096 75.5626 199.253 75.5939C199.065 75.4689 199.003 74.9691 199.19 74.8129L200.221 74.7192C200.971 74.6567 201.658 74.3131 202.095 73.1884C202.658 71.7514 203.532 69.7209 204.844 66.222L208.031 57.7874C208.468 56.6628 208.656 56.0692 208.562 55.5694C209.312 55.3507 209.843 54.7884 210.186 54.3823C210.374 54.3823 210.592 54.4448 210.655 54.6635C211.061 56.038 211.561 57.475 212.03 58.8495L216.309 71.4078C217.215 74.0944 217.621 74.563 218.965 74.7192L219.808 74.8129C220.027 74.9691 219.964 75.4689 219.808 75.5939C218.527 75.5314 217.434 75.5002 216.028 75.5002C214.529 75.5002 213.342 75.5626 212.436 75.5939C212.186 75.4689 212.154 74.9691 212.373 74.8129L213.279 74.7192C213.935 74.6567 214.372 74.4693 214.372 74.1569C214.372 73.8132 214.216 73.2509 213.966 72.5012ZM208.374 60.0366L206.406 65.4723C206.156 66.1908 206.188 66.222 207.062 66.222H210.905C211.811 66.222 211.873 66.0971 211.592 65.2536L209.905 60.1616C209.655 59.4118 209.374 58.5684 209.187 58.1935H209.124C209.031 58.3497 208.718 59.0995 208.374 60.0366Z" fill="white" />
            <path d="M228.641 56.9127V70.8143C228.641 74.0944 228.703 74.563 230.515 74.7192L231.515 74.8129C231.702 74.9379 231.64 75.5002 231.452 75.5939C229.671 75.5314 228.609 75.5002 227.36 75.5002C226.11 75.5002 225.017 75.5314 223.017 75.5939C222.83 75.5002 222.768 74.9691 223.017 74.8129L224.142 74.7192C225.923 74.563 226.079 74.0944 226.079 70.8143V56.8502C226.079 55.8818 226.079 55.8506 225.142 55.8506H223.424C222.08 55.8506 220.362 55.913 219.581 56.6315C218.831 57.3188 218.519 58.0061 218.175 58.7871C217.925 58.9745 217.488 58.8183 217.363 58.5684C217.863 57.1626 218.332 55.1633 218.55 53.9137C218.644 53.8512 219.05 53.82 219.144 53.9137C219.331 54.9134 220.362 54.8821 221.799 54.8821H234.451C236.138 54.8821 236.419 54.8197 236.888 54.0074C237.044 53.945 237.388 53.9762 237.45 54.1011C237.106 55.382 236.888 57.9124 236.982 58.8495C236.857 59.0995 236.325 59.0995 236.169 58.912C236.076 58.131 235.857 56.9752 235.388 56.6315C234.67 56.1005 233.483 55.8506 231.765 55.8506H229.547C228.609 55.8506 228.641 55.8818 228.641 56.9127Z" fill="white" />
            <path d="M241.766 70.7518V59.6305C241.766 56.3191 241.704 55.7881 239.86 55.6319L239.079 55.5694C238.892 55.4444 238.954 54.8821 239.142 54.7884C240.704 54.8509 241.766 54.8821 243.078 54.8821C244.328 54.8821 245.39 54.8509 246.952 54.7884C247.139 54.8821 247.202 55.4444 247.014 55.5694L246.233 55.6319C244.39 55.7881 244.328 56.3191 244.328 59.6305V70.7518C244.328 74.0632 244.39 74.5005 246.233 74.7192L247.014 74.8129C247.202 74.9379 247.139 75.5002 246.952 75.5939C245.39 75.5314 244.328 75.5002 243.078 75.5002C241.766 75.5002 240.704 75.5314 239.142 75.5939C238.954 75.5002 238.892 75.0003 239.079 74.8129L239.86 74.7192C241.704 74.5005 241.766 74.0632 241.766 70.7518Z" fill="white" />
            <path d="M260.881 76C253.946 76 249.76 71.0329 249.76 65.4098C249.76 59.1619 254.446 54.3823 260.881 54.3823C268.097 54.3823 271.721 59.5993 271.721 65.0974C271.721 71.4078 266.91 76 260.881 76ZM261.287 75.0316C265.036 75.0316 268.597 72.22 268.597 66.0658C268.597 60.9113 266.317 55.3507 260.35 55.3507C257.101 55.3507 252.884 57.5687 252.884 64.4102C252.884 69.0336 255.133 75.0316 261.287 75.0316Z" fill="white" />
            <path d="M293.961 62.7232V70.1895C293.961 71.1266 293.961 74.8441 294.055 75.6564C293.993 75.8438 293.805 76 293.461 76C293.087 75.4689 292.181 74.3755 289.463 71.2828L282.215 63.0356C281.372 62.0672 279.247 59.5056 278.591 58.8183H278.529C278.404 59.1932 278.373 59.9117 278.373 60.8489V67.6591C278.373 69.1273 278.404 73.1884 278.935 74.1256C279.123 74.4693 279.747 74.6567 280.528 74.7192L281.497 74.8129C281.684 75.0628 281.653 75.4377 281.434 75.5939C280.028 75.5314 278.935 75.5002 277.779 75.5002C276.467 75.5002 275.624 75.5314 274.53 75.5939C274.312 75.4377 274.28 75.0003 274.468 74.8129L275.311 74.7192C276.03 74.6255 276.53 74.438 276.686 74.0944C277.123 72.9698 277.092 69.1586 277.092 67.6591V58.6309C277.092 57.7562 277.061 57.1001 276.405 56.3816C275.967 55.9443 275.218 55.7256 274.468 55.6319L273.937 55.5694C273.749 55.382 273.749 54.9134 273.999 54.7884C275.311 54.8821 276.967 54.8821 277.529 54.8821C278.029 54.8821 278.56 54.8509 278.966 54.7884C279.591 56.3816 283.277 60.5052 284.308 61.6611L287.339 65.0662C289.494 67.4716 291.025 69.221 292.493 70.7205H292.556C292.68 70.5643 292.68 70.0645 292.68 69.4085V62.7232C292.68 61.255 292.649 57.1938 292.056 56.2567C291.868 55.9755 291.368 55.7881 290.119 55.6319L289.588 55.5694C289.369 55.382 289.4 54.8821 289.65 54.7884C291.087 54.8509 292.149 54.8821 293.336 54.8821C294.68 54.8821 295.492 54.8509 296.554 54.7884C296.804 54.9446 296.804 55.382 296.617 55.5694L296.179 55.6319C295.18 55.7881 294.555 56.038 294.43 56.2879C293.899 57.4125 293.961 61.2862 293.961 62.7232Z" fill="white" />
            <path d="M113 45.1516C113 44.9838 113.136 44.8477 113.304 44.8477H297.214C297.382 44.8477 297.518 44.9838 297.518 45.1516V47.5835C297.518 47.7514 297.382 47.8875 297.214 47.8875H113.304C113.136 47.8875 113 47.7514 113 47.5835V45.1516Z" fill="#CCAD61" />
        </svg>

    )
}

export const EnrolStar = () => {
    return (
        <svg width="26" height="28" viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2466_5227)">
                <path d="M15.4154 3.62015L17.5026 7.84929V7.85391L18.1641 9.19416L24.3154 10.088C25.6072 10.2757 26.123 11.8633 25.1883 12.7745L20.7371 17.1132L21.7879 23.2397C22.0085 24.5263 20.6581 25.5075 19.5026 24.9L14.0019 22.008L8.50117 24.9C8.25953 25.027 8.00936 25.0845 7.76682 25.0844C6.84864 25.0851 6.03896 24.2581 6.21363 23.2397L7.26441 17.1132L2.81329 12.7745C1.8785 11.8633 2.39433 10.2757 3.68618 10.088L9.83747 9.19416L12.5884 3.62015C12.8775 3.03445 13.4398 2.7418 14.0019 2.74219C14.564 2.74178 15.1263 3.03444 15.4154 3.62015ZM17.5026 10.8317V21.8714L20.0031 23.186L18.9968 17.3184C18.9091 16.8074 19.0785 16.2861 19.4497 15.9243L23.7128 11.7688L17.8213 10.9127C17.7114 10.8968 17.6047 10.8694 17.5026 10.8317Z" fill="#1D83F8" />
            </g>
            <defs>
                <clipPath id="clip0_2466_5227">
                    <rect width="25.1208" height="28" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export const EnrolStudents = () => {
    return (
        <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.1469 2.33334C7.09945 2.33334 2.19141 7.56001 2.19141 14C2.19141 20.44 7.09945 25.6667 13.1469 25.6667C19.1943 25.6667 24.1023 20.44 24.1023 14C24.1023 7.56001 19.1943 2.33334 13.1469 2.33334ZM17.1018 9.73001C18.274 9.73001 19.2162 10.7333 19.2162 11.9817C19.2162 13.23 18.274 14.2333 17.1018 14.2333C15.9295 14.2333 14.9874 13.23 14.9874 11.9817C14.9764 10.7333 15.9295 9.73001 17.1018 9.73001ZM13.114 10.64C13.114 9.12334 11.9527 7.88668 10.5285 7.88668C9.09334 7.88668 7.94302 9.11168 7.94302 10.64C7.94302 12.1567 9.10429 13.3933 10.5285 13.3933C11.9527 13.3933 13.114 12.1567 13.114 10.64ZM10.5285 18.5383V22.9133C7.89919 22.0383 5.81766 19.88 4.8974 17.1267C6.04772 15.82 8.91805 15.155 10.5285 15.155C11.1091 15.155 11.8432 15.2483 12.61 15.4117C10.8133 16.4267 10.5285 17.7683 10.5285 18.5383ZM12.2814 23.2867C12.5662 23.3217 12.8511 23.3333 13.1469 23.3333C16.8607 23.3333 20.0269 20.86 21.3087 17.395C20.3008 16.5083 18.274 16.0533 17.1018 16.0533C15.5023 16.0533 12.2814 16.8817 12.2814 18.5383V23.2867Z" fill="#1D83F8" />
        </svg>

    )
}

export const EnrolReviews = () => {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.334 2.33334H4.66732C3.38398 2.33334 2.33398 3.38334 2.33398 4.66668V25.6667L7.00065 21H23.334C24.6173 21 25.6673 19.95 25.6673 18.6667V4.66668C25.6673 3.38334 24.6173 2.33334 23.334 2.33334ZM7.00065 16.3333V13.4517L15.0273 5.42501C15.2607 5.19168 15.6223 5.19168 15.8557 5.42501L17.9207 7.49001C18.154 7.72334 18.154 8.08501 17.9207 8.31834L9.88232 16.3333H7.00065ZM12.2507 16.3333H19.834C20.4757 16.3333 21.0007 15.8083 21.0007 15.1667C21.0007 14.525 20.4757 14 19.834 14H14.584L12.2507 16.3333Z" fill="#1D83F8" />
        </svg>

    )
}

export const EnrolLanguage = () => {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.33594 8.45964C2.33594 6.36555 4.03352 4.66797 6.1276 4.66797H21.8776C23.9717 4.66797 25.6693 6.36555 25.6693 8.45964V19.543C25.6693 21.637 23.9717 23.3346 21.8776 23.3346H6.1276C4.03352 23.3346 2.33594 21.637 2.33594 19.543V8.45964ZM5.83594 15.4596C5.83594 15.9429 6.22769 16.3346 6.71094 16.3346H15.4609C15.9442 16.3346 16.3359 15.9429 16.3359 15.4596C16.3359 14.9764 15.9442 14.5846 15.4609 14.5846H6.71094C6.22769 14.5846 5.83594 14.9764 5.83594 15.4596ZM18.3776 14.5846C17.8944 14.5846 17.5026 14.9764 17.5026 15.4596C17.5026 15.9429 17.8944 16.3346 18.3776 16.3346H21.2943C21.7775 16.3346 22.1693 15.9429 22.1693 15.4596C22.1693 14.9764 21.7775 14.5846 21.2943 14.5846H18.3776ZM5.83594 18.9596C5.83594 19.4429 6.22769 19.8346 6.71094 19.8346H10.7943C11.2775 19.8346 11.6693 19.4429 11.6693 18.9596C11.6693 18.4764 11.2775 18.0846 10.7943 18.0846H6.71094C6.22769 18.0846 5.83594 18.4764 5.83594 18.9596ZM13.7109 18.0846C13.2277 18.0846 12.8359 18.4764 12.8359 18.9596C12.8359 19.4429 13.2277 19.8346 13.7109 19.8346H21.2943C21.7775 19.8346 22.1693 19.4429 22.1693 18.9596C22.1693 18.4764 21.7775 18.0846 21.2943 18.0846H13.7109Z" fill="#1D83F8" />
        </svg>
    )
}

export const EnrolWishlist = () => {
    return (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_b_3172_9252)">
                <rect width="60" height="60" rx="30" fill="#3D3D3D" />
                <rect x="0.5" y="0.5" width="59" height="59" rx="29.5" stroke="#7F7F7F" />
                <path d="M25.5 21.5C22.4712 21.5 20 23.9712 20 27C20 29.0481 21.5438 30.9764 23.4258 32.9541C25.3077 34.9318 27.6242 36.9347 29.4697 38.7803C29.6104 38.9209 29.8011 38.9999 30 38.9999C30.1989 38.9999 30.3896 38.9209 30.5303 38.7803C32.3758 36.9347 34.6923 34.9318 36.5742 32.9541C38.4562 30.9764 40 29.0481 40 27C40 23.9712 37.5288 21.5 34.5 21.5C32.7618 21.5 31.2484 22.4332 30 24.0186C28.7516 22.4332 27.2382 21.5 25.5 21.5ZM25.5 23C26.9643 23 28.1832 23.7792 29.3662 25.6504C29.4339 25.7573 29.5274 25.8453 29.6383 25.9063C29.7491 25.9673 29.8735 25.9993 30 25.9993C30.1265 25.9993 30.2509 25.9673 30.3617 25.9063C30.4726 25.8453 30.5661 25.7573 30.6338 25.6504C31.8168 23.7792 33.0357 23 34.5 23C36.7182 23 38.5 24.7818 38.5 27C38.5 28.2019 37.2938 30.0236 35.4883 31.9209C33.8418 33.6511 31.7952 35.4587 30 37.209C28.2048 35.4587 26.1582 33.6511 24.5117 31.9209C22.7062 30.0236 21.5 28.2019 21.5 27C21.5 24.7818 23.2818 23 25.5 23Z" fill="white" />
            </g>
            <defs>
                <filter id="filter0_b_3172_9252" x="-20" y="-20" width="100" height="100" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3172_9252" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_3172_9252" result="shape" />
                </filter>
            </defs>
        </svg>

    )
}
export const Wishlist = () => {
    return (
        <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.2322 12.1632L19.2303 12.1657C18.7938 12.7238 17.5403 13.9152 16.0553 15.2537C14.595 16.5699 12.977 17.9703 11.8679 18.9205L11.867 18.9214C11.3573 19.3595 10.6426 19.3595 10.133 18.9214L10.132 18.9205C9.02312 17.9704 7.40616 16.57 5.94636 15.2538C4.46231 13.9156 3.20786 12.7235 2.76873 12.1645L2.76838 12.164C1.36158 10.3759 0.75 8.73521 0.75 6.98017C0.75 5.22637 1.31707 3.65012 2.30877 2.51602C3.31407 1.37239 4.67092 0.75 6.14573 0.75C7.23587 0.75 8.23009 1.11045 9.12552 1.84C9.60317 2.23435 10.0256 2.69657 10.3744 3.21811L10.992 4.14143L11.6176 3.2235C11.9754 2.69848 12.3964 2.23098 12.8711 1.83927C13.7641 1.10752 14.7616 0.75 15.8543 0.75C17.3338 0.75 18.6898 1.37266 19.6901 2.51473C20.6794 3.65028 21.25 5.22319 21.25 6.98017L21.25 6.98182C21.2538 8.73552 20.6429 10.3753 19.2322 12.1632Z" fill="white" stroke="white" stroke-width="1.5" />
        </svg>

    )
}

export const CourseButtonArrow = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="20" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.125 20C13.125 19.6548 13.4048 19.375 13.75 19.375L24.7411 19.375L20.1831 14.8169C19.939 14.5729 19.939 14.1771 20.1831 13.9331C20.4271 13.689 20.8229 13.689 21.0669 13.9331L26.6919 19.5581C26.936 19.8021 26.936 20.1979 26.6919 20.4419L21.0669 26.0669C20.8229 26.311 20.4271 26.311 20.1831 26.0669C19.939 25.8229 19.939 25.4271 20.1831 25.1831L24.7411 20.625L13.75 20.625C13.4048 20.625 13.125 20.3452 13.125 20Z" fill="#0F6EB6" />
        </svg>

    )
}

export const GetInTouch = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="20" fill="#1D83F8" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.125 20C13.125 19.6548 13.4048 19.375 13.75 19.375L24.7411 19.375L20.1831 14.8169C19.939 14.5729 19.939 14.1771 20.1831 13.9331C20.4271 13.689 20.8229 13.689 21.0669 13.9331L26.6919 19.5581C26.936 19.8021 26.936 20.1979 26.6919 20.4419L21.0669 26.0669C20.8229 26.311 20.4271 26.311 20.1831 26.0669C19.939 25.8229 19.939 25.4271 20.1831 25.1831L24.7411 20.625L13.75 20.625C13.4048 20.625 13.125 20.3452 13.125 20Z" fill="white" />
        </svg>

    )
}


export const CourseFacebook = () => {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="44" height="44" rx="22" fill="white" />
            <g clip-path="url(#clip0_2466_5427)">
                <path d="M32 22C32 16.4771 27.5229 12 22 12C16.4771 12 12 16.4771 12 22C12 26.9912 15.6568 31.1283 20.4375 31.8785V24.8906H17.8984V22H20.4375V19.7969C20.4375 17.2906 21.9305 15.9062 24.2146 15.9062C25.3084 15.9062 26.4531 16.1016 26.4531 16.1016V18.5625H25.1922C23.95 18.5625 23.5625 19.3334 23.5625 20.125V22H26.3359L25.8926 24.8906H23.5625V31.8785C28.3432 31.1283 32 26.9912 32 22Z" fill="#1D83F8" />
            </g>
            <defs>
                <clipPath id="clip0_2466_5427">
                    <rect width="20" height="20" fill="white" transform="translate(12 12)" />
                </clipPath>
            </defs>
        </svg>

    )
}

export const CourseTwitter = () => {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="44" height="44" rx="22" fill="white" />
            <path d="M18.2918 30.1256C25.8371 30.1256 29.9652 23.8729 29.9652 18.4522C29.9652 18.2764 29.9613 18.0967 29.9535 17.9209C30.7566 17.3402 31.4496 16.6208 32 15.7967C31.2521 16.1294 30.458 16.3468 29.6449 16.4412C30.5011 15.928 31.1421 15.1218 31.4492 14.1721C30.6438 14.6494 29.763 14.9861 28.8445 15.1678C28.2257 14.5102 27.4075 14.0749 26.5164 13.929C25.6253 13.7831 24.711 13.9348 23.9148 14.3607C23.1186 14.7866 22.4848 15.4629 22.1115 16.285C21.7382 17.1072 21.6462 18.0295 21.8496 18.9092C20.2187 18.8274 18.6233 18.4037 17.1667 17.6657C15.71 16.9277 14.4247 15.8918 13.3941 14.6252C12.8703 15.5283 12.71 16.597 12.9459 17.614C13.1817 18.6311 13.7959 19.5201 14.6637 20.1006C14.0122 20.0799 13.375 19.9045 12.8047 19.5889V19.6397C12.8041 20.5874 13.1317 21.5061 13.7319 22.2396C14.3321 22.9731 15.1678 23.4761 16.0969 23.6631C15.4934 23.8282 14.86 23.8523 14.2457 23.7334C14.5079 24.5485 15.018 25.2614 15.7048 25.7726C16.3916 26.2838 17.2209 26.5678 18.077 26.585C16.6237 27.7265 14.8285 28.3457 12.9805 28.3428C12.6527 28.3423 12.3253 28.3222 12 28.2826C13.8774 29.4871 16.0613 30.1268 18.2918 30.1256Z" fill="#1D83F8" />
        </svg>
    )
}

export const CourseLinkedIn = () => {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="44" height="44" rx="22" fill="white" />
            <g clip-path="url(#clip0_2466_5433)">
                <path d="M30.5195 12H13.4766C12.6602 12 12 12.6445 12 13.4414V30.5547C12 31.3516 12.6602 32 13.4766 32H30.5195C31.3359 32 32 31.3516 32 30.5586V13.4414C32 12.6445 31.3359 12 30.5195 12ZM17.9336 29.043H14.9648V19.4961H17.9336V29.043ZM16.4492 18.1953C15.4961 18.1953 14.7266 17.4258 14.7266 16.4766C14.7266 15.5273 15.4961 14.7578 16.4492 14.7578C17.3984 14.7578 18.168 15.5273 18.168 16.4766C18.168 17.4219 17.3984 18.1953 16.4492 18.1953ZM29.043 29.043H26.0781V24.4023C26.0781 23.2969 26.0586 21.8711 24.5352 21.8711C22.9922 21.8711 22.7578 23.0781 22.7578 24.3242V29.043H19.7969V19.4961H22.6406V20.8008H22.6797C23.0742 20.0508 24.043 19.2578 25.4844 19.2578C28.4883 19.2578 29.043 21.2344 29.043 23.8047V29.043Z" fill="#1D83F8" />
            </g>
            <defs>
                <clipPath id="clip0_2466_5433">
                    <rect width="20" height="20" fill="white" transform="translate(12 12)" />
                </clipPath>
            </defs>
        </svg>

    )
}



export const ExpandIcon = () => {
    return (
        <svg width="38" height="38" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="white" />
            <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#EEF3F7" />
            <path d="M29.8359 23.1673H24.8359V18.1673C24.8359 17.9463 24.7481 17.7343 24.5919 17.5781C24.4356 17.4218 24.2236 17.334 24.0026 17.334C23.7816 17.334 23.5696 17.4218 23.4133 17.5781C23.2571 17.7343 23.1693 17.9463 23.1693 18.1673V23.1673H18.1693C17.9483 23.1673 17.7363 23.2551 17.58 23.4114C17.4237 23.5677 17.3359 23.7796 17.3359 24.0007C17.3359 24.2217 17.4237 24.4336 17.58 24.5899C17.7363 24.7462 17.9483 24.834 18.1693 24.834H23.1693V29.834C23.1693 30.055 23.2571 30.267 23.4133 30.4232C23.5696 30.5795 23.7816 30.6673 24.0026 30.6673C24.2236 30.6673 24.4356 30.5795 24.5919 30.4232C24.7481 30.267 24.8359 30.055 24.8359 29.834V24.834H29.8359C30.057 24.834 30.2689 24.7462 30.4252 24.5899C30.5815 24.4336 30.6693 24.2217 30.6693 24.0007C30.6693 23.7796 30.5815 23.5677 30.4252 23.4114C30.2689 23.2551 30.057 23.1673 29.8359 23.1673Z" fill="#333333" />
        </svg>

    )
}


export const MinimizeIcon = () => {
    return (
        <svg width="38" height="38" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="white" />
            <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#EEF3F7" />
            <path d="M29.8359 23.166H18.1693C17.9483 23.166 17.7363 23.2538 17.58 23.4101C17.4237 23.5664 17.3359 23.7783 17.3359 23.9993C17.3359 24.2204 17.4237 24.4323 17.58 24.5886C17.7363 24.7449 17.9483 24.8327 18.1693 24.8327H29.8359C30.057 24.8327 30.2689 24.7449 30.4252 24.5886C30.5815 24.4323 30.6693 24.2204 30.6693 23.9993C30.6693 23.7783 30.5815 23.5664 30.4252 23.4101C30.2689 23.2538 30.057 23.166 29.8359 23.166Z" fill="#1E1E1E" />
        </svg>

    )
}

export const FolderIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.5 16.25V5C2.5 4.83424 2.56585 4.67527 2.68306 4.55806C2.80027 4.44085 2.95924 4.375 3.125 4.375H7.29167C7.4269 4.375 7.55848 4.41886 7.66667 4.5L9.83333 6.125C9.94152 6.20614 10.0731 6.25 10.2083 6.25H15.625C15.7908 6.25 15.9497 6.31585 16.0669 6.43306C16.1842 6.55027 16.25 6.70924 16.25 6.875V8.75" stroke="url(#paint0_linear_3526_4283)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2.5 16.25L4.84285 10.3929C4.88924 10.2769 4.96932 10.1775 5.07275 10.1075C5.17619 10.0374 5.29823 10 5.42315 10H9.18576C9.30916 10 9.42979 9.96348 9.53245 9.89503L11.0925 8.85497C11.1952 8.78652 11.3158 8.75 11.4392 8.75H17.8829C17.9819 8.75 18.0795 8.77353 18.1677 8.81866C18.2558 8.86379 18.332 8.92922 18.3899 9.00956C18.4478 9.0899 18.4858 9.18284 18.5007 9.28074C18.5156 9.37864 18.5071 9.47869 18.4758 9.57264L16.25 16.25H2.5Z" stroke="url(#paint1_linear_3526_4283)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_3526_4283" x1="2.5" y1="10.3125" x2="13.0949" y2="10.3948" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1D83F8" />
                    <stop offset="1" stop-color="#866EC7" />
                </linearGradient>
                <linearGradient id="paint1_linear_3526_4283" x1="2.5" y1="12.5" x2="14.8328" y2="12.6766" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1D83F8" />
                    <stop offset="1" stop-color="#866EC7" />
                </linearGradient>
            </defs>
        </svg>

    )
}

export const MXIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="url(#paint0_linear_3526_3932)" stroke-width="1.3" stroke-miterlimit="10" />
            <path d="M12.5 10L8.75 7.5V12.5L12.5 10Z" stroke="url(#paint1_linear_3526_3932)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_3526_3932" x1="2.5" y1="10" x2="14.0582" y2="10.0775" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1D83F8" />
                    <stop offset="1" stop-color="#866EC7" />
                </linearGradient>
                <linearGradient id="paint1_linear_3526_3932" x1="8.75" y1="10" x2="11.6396" y2="10.0145" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1D83F8" />
                    <stop offset="1" stop-color="#866EC7" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const ClockIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="url(#paint0_linear_3526_4207)" stroke-width="1.3" stroke-miterlimit="10" />
            <path d="M10 5.625V10H14.375" stroke="url(#paint1_linear_3526_4207)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_3526_4207" x1="2.5" y1="10" x2="14.0582" y2="10.0775" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1D83F8" />
                    <stop offset="1" stop-color="#866EC7" />
                </linearGradient>
                <linearGradient id="paint1_linear_3526_4207" x1="10" y1="7.8125" x2="13.3711" y2="7.83511" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1D83F8" />
                    <stop offset="1" stop-color="#866EC7" />
                </linearGradient>
            </defs>
        </svg>
    )
}


export const CurriculumPlayIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.5933 7.57363L4.59472 2.07434C4.51892 2.02802 4.43216 2.00273 4.34335 2.00106C4.25453 1.9994 4.16688 2.02143 4.08941 2.06488C4.01193 2.10833 3.94743 2.17163 3.90254 2.24828C3.85765 2.32493 3.83398 2.41215 3.83398 2.50098V13.4996C3.83398 13.5884 3.85765 13.6756 3.90254 13.7523C3.94743 13.8289 4.01193 13.8922 4.08941 13.9357C4.16688 13.9791 4.25453 14.0011 4.34335 13.9995C4.43216 13.9978 4.51892 13.9725 4.59472 13.9262L13.5933 8.4269C13.6663 8.38224 13.7267 8.31955 13.7686 8.24484C13.8105 8.17014 13.8325 8.08592 13.8325 8.00027C13.8325 7.91461 13.8105 7.8304 13.7686 7.75569C13.7267 7.68098 13.6663 7.61829 13.5933 7.57363Z" fill="#1D2026" />
        </svg>

    )
}



export const CurriculumFileIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 14H3.49998C3.36737 14 3.2402 13.9473 3.14643 13.8535C3.05267 13.7598 3 13.6326 3 13.5V2.5C3 2.3674 3.05267 2.24022 3.14643 2.14645C3.2402 2.05268 3.36737 2 3.49998 2H9.50017L13 5.5V13.5C13 13.6326 12.9473 13.7598 12.8536 13.8535C12.7598 13.9473 12.6326 14 12.5 14Z" fill="white" stroke="#1D2026" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.5 2V5.5H13.0005" fill="#1D2026" />
            <path d="M9.5 2V5.5H13.0005" stroke="#1D2026" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export const UnreadMessage = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="7" fill="#1D83F8" stroke="white" stroke-width="2" />
        </svg>
    )
}


export const RoundError = () => {
    return (
        <svg width="81" height="80" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="40.5" cy="40" r="40" fill="#DC3545" />
            <path d="M48.5 32L32.5 48M32.5001 32L48.5001 48" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}



export const SquareO = () => {
    return (
        <svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M44.2235 68.5266C33.1305 71.4991 24.1618 71.0357 17.3176 67.1368C10.5407 63.2197 5.6537 55.6695 2.65736 44.4862C-0.339665 33.3022 0.117698 24.32 4.02742 17.5398C8.00578 10.7412 15.5412 5.85561 26.6342 2.88309C37.7946 -0.107104 46.7632 0.356379 53.5395 4.27353C60.3681 8.11117 65.2883 15.6526 68.3017 26.897C71.3143 38.1415 70.8318 47.1631 66.8541 53.9617C62.9274 60.6814 55.3839 65.5364 44.2235 68.5266Z" fill="#E39A4D" />
        </svg>
    )
}

export const SquareG = () => {
    return (
        <svg width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.6546 65.6334C9.71212 59.8915 3.69765 53.222 1.61129 45.6256C-0.407116 38.0638 1.47533 29.2699 7.2655 19.2426C13.0557 9.21596 19.7294 3.18733 27.2865 1.15808C34.9048 -0.836511 43.692 1.03711 53.6345 6.77896C63.6381 12.5561 69.6525 19.2256 71.6777 26.7867C73.7913 34.3288 71.936 43.141 66.1187 53.2221C60.2945 63.3038 53.5801 69.3419 45.955 71.3365C38.4319 73.3114 29.6583 71.4106 19.6546 65.6334Z" fill="#A5C8D8" />
        </svg>

    )
}


export const PolyG = () => {
    return (
        <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.5991 2.69885C41.5184 1.11269 44.4773 0.319619 47.2915 1.07396C50.1058 1.82763 52.2723 3.99416 56.6054 8.32722L66.7205 18.4422C71.0536 22.7753 73.2202 24.9418 73.9738 27.756C74.7282 30.5702 73.9351 33.5298 72.3489 39.4483L68.6465 53.2657C67.061 59.1842 66.2679 62.1439 64.2074 64.2044C62.1475 66.2642 59.1879 67.0573 53.2693 68.6434L39.4517 72.3458C33.5324 73.9313 30.5735 74.7244 27.7592 73.9707C24.9444 73.2164 22.7785 71.0499 18.4454 66.7168L8.33023 56.6018C3.99712 52.2688 1.83057 50.1029 1.07689 47.2887C0.32254 44.4739 1.11564 41.5149 2.70182 35.5957L6.40427 21.7783C7.98977 15.8598 8.78284 12.9002 10.8434 10.8403C12.9032 8.77982 15.8629 7.98673 21.7815 6.40125L35.5991 2.69885Z" fill="#A5C8D8" />
        </svg>

    )
}


export const PolyP = () => {
    return (
        <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.7173 2.47623C41.6366 0.890072 44.5996 0.0969561 47.4132 0.8513C50.2267 1.60564 52.3946 3.77152 56.7236 8.10457L66.8428 18.2196C71.1719 22.5526 73.3398 24.7192 74.0942 27.5333C74.8485 30.3475 74.0534 33.3071 72.4699 39.2257L68.7661 53.043C67.1826 58.9623 66.3875 61.9212 64.3284 63.9817C62.2692 66.0415 59.3061 66.8346 53.3868 68.4208L39.5706 72.1232C33.6513 73.7087 30.6951 74.5018 27.8816 73.7481C25.0612 72.9938 22.9001 70.8272 18.5642 66.4948L8.45184 56.3791C4.11601 52.0468 1.94814 49.8802 1.19379 47.0661C0.439434 44.2519 1.23457 41.2923 2.81803 35.3737L6.5218 21.5557C8.11206 15.6371 8.90041 12.6775 10.9596 10.6177C13.0256 8.55718 15.9818 7.76411 21.9011 6.17863L35.7173 2.47623Z" fill="#CBB0EB" />
        </svg>

    )
}


export const Duration = () => {
    return (
        <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2531_999)">
                <path d="M21.5 6.45C13.1687 6.45 6.45 13.1687 6.45 21.5C6.45 29.8312 13.1687 36.55 21.5 36.55C29.8312 36.55 36.55 29.8312 36.55 21.5C36.55 13.1687 29.8312 6.45 21.5 6.45ZM27.4125 27.4125C27.1437 27.6812 26.8078 27.8156 26.4719 27.8156C26.1359 27.8156 25.8 27.6812 25.5312 27.4125L20.5594 22.4406C20.425 22.3063 20.3578 22.1719 20.2906 22.0375C20.2234 21.9031 20.2234 21.7016 20.2234 21.5672V11.6234C20.2234 10.8844 20.8281 10.3469 21.5 10.3469C22.2391 10.3469 22.7766 10.9516 22.7766 11.6234V20.9625L27.4125 25.5984C27.8828 26.0687 27.8828 26.875 27.4125 27.4125ZM21.5 0C9.60781 0 0 9.60781 0 21.5C0 33.3922 9.60781 43 21.5 43C33.3922 43 43 33.3922 43 21.5C43 9.60781 33.3922 0 21.5 0ZM21.5 39.1703C11.7578 39.1703 3.82969 31.2422 3.82969 21.5C3.82969 11.7578 11.7578 3.82969 21.5 3.82969C31.2422 3.82969 39.1703 11.7578 39.1703 21.5C39.1703 31.2422 31.2422 39.1703 21.5 39.1703Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_2531_999">
                    <rect width="43" height="43" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const Calendar = () => {
  return (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2531_1000)">
        <path
          d="M33.625 5.375h-2.6875V2.6875C30.9375 1.20313 29.7344 0 28.25 0c-1.4844 0-2.6875 1.20313-2.6875 2.6875V5.375h-8.125V2.6875C17.4375 1.20313 16.2344 0 14.75 0c-1.4844 0-2.6875 1.20313-2.6875 2.6875V5.375H9.375C6.24687 5.375 3.75 7.87187 3.75 11V36.125C3.75 39.2531 6.24687 41.75 9.375 41.75h24.25c3.1281 0 5.625-2.4969 5.625-5.625V11c0-3.12813-2.4969-5.625-5.625-5.625ZM33.625 36.125H9.375V17.25h24.25v18.875Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2531_1000">
          <rect width="43" height="43" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};


export const Live = () => {
    return (
        <svg width="124" height="62" viewBox="0 0 124 62" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M124 13.5625C124 6.07212 117.928 0 110.438 0C87.4723 0 36.5277 0 13.5625 0C6.07212 0 0 6.07212 0 13.5625V48.4375C0 55.9279 6.07212 62 13.5625 62H110.438C117.928 62 124 55.9279 124 48.4375C124 38.3083 124 23.6917 124 13.5625Z" fill="#76CD4E" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2399 44.7001C11.6779 37.138 11.6779 24.862 19.2399 17.3C19.9955 16.5444 19.9955 15.316 19.2399 14.5604C18.4843 13.8028 17.2559 13.8028 16.5003 14.5604C7.42698 23.6337 7.42698 38.3664 16.5003 47.4397C17.2559 48.1973 18.4843 48.1973 19.2399 47.4397C19.9955 46.6841 19.9955 45.4557 19.2399 44.7001Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M46.637 17.3C54.1991 24.862 54.1991 37.138 46.637 44.7001C45.8814 45.4557 45.8814 46.6841 46.637 47.4397C47.3927 48.1973 48.621 48.1973 49.3767 47.4397C58.45 38.3664 58.45 23.6337 49.3767 14.5604C48.621 13.8028 47.3927 13.8028 46.637 14.5604C45.8814 15.316 45.8814 16.5444 46.637 17.3Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M24.7138 39.2206C20.1781 34.683 20.1781 27.3166 24.7138 22.779C25.4713 22.0234 25.4713 20.795 24.7138 20.0394C23.9582 19.2838 22.7298 19.2838 21.9742 20.0394C15.9253 26.0883 15.9253 35.9114 21.9742 41.9602C22.7298 42.7159 23.9582 42.7159 24.7138 41.9602C25.4713 41.2046 25.4713 39.9762 24.7138 39.2206Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M41.1619 22.779C45.6976 27.3166 45.6976 34.683 41.1619 39.2206C40.4044 39.9762 40.4044 41.2046 41.1619 41.9602C41.9175 42.7159 43.1459 42.7159 43.9015 41.9602C49.9504 35.9114 49.9504 26.0883 43.9015 20.0394C43.1459 19.2838 41.9175 19.2838 41.1619 20.0394C40.4044 20.795 40.4044 22.0234 41.1619 22.779Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M106.562 29.0625V25.1875H110.438C111.507 25.1875 112.375 24.3195 112.375 23.25C112.375 22.1805 111.507 21.3125 110.438 21.3125H104.625C103.556 21.3125 102.688 22.1805 102.688 23.25V38.75C102.688 39.8195 103.556 40.6875 104.625 40.6875H110.438C111.507 40.6875 112.375 39.8195 112.375 38.75C112.375 37.6805 111.507 36.8125 110.438 36.8125H106.562V32.9375H110.438C111.507 32.9375 112.375 32.0695 112.375 31C112.375 29.9305 111.507 29.0625 110.438 29.0625H106.562Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M94.9958 22.7794L93.0001 30.7619L91.0045 22.7794C90.7448 21.7428 89.6929 21.1112 88.6544 21.3708C87.6178 21.6304 86.9862 22.6825 87.2458 23.721L91.1208 39.221C91.3359 40.0832 92.1108 40.6877 93.0001 40.6877C93.8895 40.6877 94.6644 40.0832 94.8795 39.221L98.7545 23.721C99.0141 22.6825 98.3825 21.6304 97.3459 21.3708C96.3074 21.1112 95.2554 21.7428 94.9958 22.7794Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M83.3125 38.75V23.25C83.3125 22.1805 82.4445 21.3125 81.375 21.3125C80.3055 21.3125 79.4375 22.1805 79.4375 23.25V38.75C79.4375 39.8195 80.3055 40.6875 81.375 40.6875C82.4445 40.6875 83.3125 39.8195 83.3125 38.75Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M65.875 23.25V38.75C65.875 39.8195 66.743 40.6875 67.8125 40.6875H73.625C74.6945 40.6875 75.5625 39.8195 75.5625 38.75C75.5625 37.6805 74.6945 36.8125 73.625 36.8125H69.75V23.25C69.75 22.1805 68.882 21.3125 67.8125 21.3125C66.743 21.3125 65.875 22.1805 65.875 23.25Z" fill="white" />
            <path d="M32.9375 36.8125C36.1477 36.8125 38.75 34.2102 38.75 31C38.75 27.7898 36.1477 25.1875 32.9375 25.1875C29.7273 25.1875 27.125 27.7898 27.125 31C27.125 34.2102 29.7273 36.8125 32.9375 36.8125Z" fill="white" />
        </svg>
    )
}

export const Recorded = () => {
    return (
        <svg width="139" height="62" viewBox="0 0 139 62" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M139 13.5625C139 6.07213 132.193 0 123.797 0C98.0536 0 40.9464 0 15.2031 0C6.80666 0 0 6.07213 0 13.5625V48.4375C0 55.9279 6.80666 62 15.2031 62H123.797C132.193 62 139 55.9279 139 48.4375C139 38.3082 139 23.6918 139 13.5625Z" fill="#76CD4E" />
            <path d="M41.0458 38V24.1818H46.7539C47.7885 24.1818 48.6813 24.3685 49.4325 24.7418C50.1882 25.1107 50.7707 25.6415 51.18 26.3342C51.5894 27.0224 51.794 27.8388 51.794 28.7834C51.794 29.7415 51.5849 30.5556 51.1665 31.2259C50.7482 31.8916 50.1545 32.3999 49.3853 32.7507C48.6161 33.0971 47.7053 33.2702 46.6527 33.2702H43.043V30.6388H46.032C46.5357 30.6388 46.9563 30.5736 47.2937 30.4432C47.6355 30.3082 47.8942 30.1058 48.0696 29.8359C48.245 29.5616 48.3327 29.2107 48.3327 28.7834C48.3327 28.3561 48.245 28.003 48.0696 27.7241C47.8942 27.4407 47.6355 27.2293 47.2937 27.0898C46.9518 26.9459 46.5313 26.8739 46.032 26.8739H44.3857V38H41.0458ZM48.8253 31.6847L52.2663 38H48.6229L45.2493 31.6847H48.8253ZM58.2662 38.1957C57.1822 38.1957 56.2466 37.982 55.4594 37.5547C54.6768 37.1229 54.074 36.5089 53.6512 35.7127C53.2329 34.9121 53.0237 33.9607 53.0237 32.8587C53.0237 31.7881 53.2351 30.8525 53.6579 30.0518C54.0808 29.2467 54.6768 28.6214 55.4459 28.1761C56.2151 27.7263 57.1215 27.5014 58.165 27.5014C58.9027 27.5014 59.5774 27.6161 60.1892 27.8455C60.8009 28.0749 61.3295 28.4145 61.7748 28.8643C62.2201 29.3142 62.5664 29.8697 62.8138 30.5309C63.0612 31.1876 63.1849 31.9411 63.1849 32.7912V33.6143H54.1775V31.6982H60.115C60.1105 31.3473 60.0273 31.0347 59.8653 30.7603C59.7034 30.4859 59.4807 30.2723 59.1974 30.1193C58.9185 29.9619 58.5969 29.8832 58.2325 29.8832C57.8637 29.8832 57.5331 29.9664 57.2407 30.1328C56.9483 30.2947 56.7166 30.5174 56.5457 30.8008C56.3748 31.0797 56.2848 31.3968 56.2758 31.7521V33.7021C56.2758 34.1249 56.359 34.496 56.5255 34.8153C56.6919 35.1302 56.9281 35.3754 57.2339 35.5508C57.5398 35.7262 57.9041 35.8139 58.327 35.8139C58.6193 35.8139 58.8847 35.7734 59.1231 35.6925C59.3615 35.6115 59.5662 35.4923 59.7371 35.3349C59.9081 35.1774 60.0363 34.984 60.1217 34.7546L63.1512 34.8423C63.0252 35.5215 62.7486 36.113 62.3213 36.6168C61.8985 37.1161 61.343 37.5052 60.6547 37.7841C59.9665 38.0585 59.1704 38.1957 58.2662 38.1957ZM69.7077 38.1957C68.6147 38.1957 67.6768 37.9708 66.8942 37.521C66.116 37.0711 65.5178 36.4459 65.0994 35.6452C64.6811 34.8401 64.4719 33.909 64.4719 32.8519C64.4719 31.7904 64.6811 30.8593 65.0994 30.0586C65.5223 29.2534 66.1228 28.6259 66.9009 28.1761C67.6836 27.7263 68.617 27.5014 69.701 27.5014C70.6591 27.5014 71.4935 27.6746 72.2042 28.021C72.9194 28.3673 73.4772 28.8576 73.8775 29.4918C74.2823 30.1216 74.496 30.8615 74.5185 31.7116H71.435C71.372 31.1809 71.1921 30.7648 70.8952 30.4634C70.6029 30.162 70.2205 30.0114 69.7482 30.0114C69.3659 30.0114 69.0308 30.1193 68.7429 30.3352C68.455 30.5466 68.2301 30.8615 68.0682 31.2798C67.9107 31.6937 67.832 32.2064 67.832 32.8182C67.832 33.4299 67.9107 33.9472 68.0682 34.37C68.2301 34.7884 68.455 35.1055 68.7429 35.3214C69.0308 35.5328 69.3659 35.6385 69.7482 35.6385C70.0541 35.6385 70.324 35.5733 70.5579 35.4428C70.7963 35.3124 70.992 35.1212 71.1449 34.8693C71.2978 34.6129 71.3945 34.3026 71.435 33.9382H74.5185C74.487 34.7929 74.2733 35.5395 73.8775 36.1783C73.4862 36.817 72.9351 37.314 72.2244 37.6694C71.5182 38.0202 70.6793 38.1957 69.7077 38.1957ZM81.0447 38.1957C79.9561 38.1957 79.0205 37.973 78.2378 37.5277C77.4597 37.0779 76.8592 36.4527 76.4363 35.652C76.018 34.8468 75.8089 33.9135 75.8089 32.8519C75.8089 31.7859 76.018 30.8525 76.4363 30.0518C76.8592 29.2467 77.4597 28.6214 78.2378 28.1761C79.0205 27.7263 79.9561 27.5014 81.0447 27.5014C82.1332 27.5014 83.0666 27.7263 83.8447 28.1761C84.6274 28.6214 85.2279 29.2467 85.6462 30.0518C86.069 30.8525 86.2805 31.7859 86.2805 32.8519C86.2805 33.9135 86.069 34.8468 85.6462 35.652C85.2279 36.4527 84.6274 37.0779 83.8447 37.5277C83.0666 37.973 82.1332 38.1957 81.0447 38.1957ZM81.0649 35.706C81.4607 35.706 81.7958 35.5845 82.0702 35.3416C82.3446 35.0987 82.5538 34.7614 82.6977 34.3295C82.8461 33.8977 82.9204 33.3984 82.9204 32.8317C82.9204 32.2559 82.8461 31.7521 82.6977 31.3203C82.5538 30.8885 82.3446 30.5511 82.0702 30.3082C81.7958 30.0653 81.4607 29.9439 81.0649 29.9439C80.6556 29.9439 80.3092 30.0653 80.0258 30.3082C79.747 30.5511 79.5333 30.8885 79.3849 31.3203C79.2409 31.7521 79.1689 32.2559 79.1689 32.8317C79.1689 33.3984 79.2409 33.8977 79.3849 34.3295C79.5333 34.7614 79.747 35.0987 80.0258 35.3416C80.3092 35.5845 80.6556 35.706 81.0649 35.706ZM87.9706 38V27.6364H91.1755V29.5256H91.2835C91.4724 28.8419 91.7805 28.3336 92.2078 28.0007C92.6352 27.6634 93.1322 27.4947 93.699 27.4947C93.8519 27.4947 94.0093 27.5059 94.1713 27.5284C94.3332 27.5464 94.4839 27.5756 94.6233 27.6161V30.4837C94.4659 30.4297 94.259 30.387 94.0026 30.3555C93.7507 30.324 93.5258 30.3082 93.3279 30.3082C92.9365 30.3082 92.5834 30.396 92.2686 30.5714C91.9582 30.7423 91.713 30.983 91.5331 31.2933C91.3577 31.5992 91.27 31.959 91.27 32.3729V38H87.9706ZM99.2148 38.1484C98.4501 38.1484 97.7551 37.9505 97.1299 37.5547C96.5046 37.1589 96.0054 36.5651 95.632 35.7734C95.2587 34.9818 95.072 33.9989 95.072 32.8249C95.072 31.6059 95.2654 30.6029 95.6523 29.8157C96.0391 29.0285 96.5451 28.446 97.1704 28.0682C97.8001 27.6903 98.4771 27.5014 99.2013 27.5014C99.7455 27.5014 100.211 27.5959 100.598 27.7848C100.985 27.9692 101.304 28.2076 101.556 28.5C101.808 28.7924 101.999 29.096 102.13 29.4109H102.197V24.1818H105.496V38H102.231V36.32H102.13C101.99 36.6393 101.792 36.9384 101.536 37.2173C101.279 37.4962 100.958 37.7211 100.571 37.892C100.189 38.063 99.7365 38.1484 99.2148 38.1484ZM100.362 35.5778C100.762 35.5778 101.104 35.4653 101.387 35.2404C101.671 35.011 101.889 34.6894 102.042 34.2756C102.195 33.8617 102.271 33.3759 102.271 32.8182C102.271 32.2514 102.195 31.7634 102.042 31.354C101.893 30.9447 101.675 30.6299 101.387 30.4094C101.104 30.189 100.762 30.0788 100.362 30.0788C99.9524 30.0788 99.6061 30.1913 99.3227 30.4162C99.0393 30.6411 98.8234 30.9582 98.675 31.3675C98.531 31.7769 98.4591 32.2604 98.4591 32.8182C98.4591 33.3759 98.5333 33.8617 98.6817 34.2756C98.8302 34.6894 99.0438 35.011 99.3227 35.2404C99.6061 35.4653 99.9524 35.5778 100.362 35.5778ZM112.427 38.1957C111.343 38.1957 110.408 37.982 109.621 37.5547C108.838 37.1229 108.235 36.5089 107.812 35.7127C107.394 34.9121 107.185 33.9607 107.185 32.8587C107.185 31.7881 107.396 30.8525 107.819 30.0518C108.242 29.2467 108.838 28.6214 109.607 28.1761C110.376 27.7263 111.283 27.5014 112.326 27.5014C113.064 27.5014 113.739 27.6161 114.35 27.8455C114.962 28.0749 115.491 28.4145 115.936 28.8643C116.381 29.3142 116.728 29.8697 116.975 30.5309C117.222 31.1876 117.346 31.9411 117.346 32.7912V33.6143H108.339V31.6982H114.276C114.272 31.3473 114.188 31.0347 114.026 30.7603C113.865 30.4859 113.642 30.2723 113.358 30.1193C113.08 29.9619 112.758 29.8832 112.394 29.8832C112.025 29.8832 111.694 29.9664 111.402 30.1328C111.109 30.2947 110.878 30.5174 110.707 30.8008C110.536 31.0797 110.446 31.3968 110.437 31.7521V33.7021C110.437 34.1249 110.52 34.496 110.687 34.8153C110.853 35.1302 111.089 35.3754 111.395 35.5508C111.701 35.7262 112.065 35.8139 112.488 35.8139C112.78 35.8139 113.046 35.7734 113.284 35.6925C113.523 35.6115 113.727 35.4923 113.898 35.3349C114.069 35.1774 114.197 34.984 114.283 34.7546L117.312 34.8423C117.186 35.5215 116.91 36.113 116.482 36.6168C116.06 37.1161 115.504 37.5052 114.816 37.7841C114.128 38.0585 113.331 38.1957 112.427 38.1957ZM122.816 38.1484C122.052 38.1484 121.357 37.9505 120.731 37.5547C120.106 37.1589 119.607 36.5651 119.234 35.7734C118.86 34.9818 118.674 33.9989 118.674 32.8249C118.674 31.6059 118.867 30.6029 119.254 29.8157C119.641 29.0285 120.147 28.446 120.772 28.0682C121.402 27.6903 122.079 27.5014 122.803 27.5014C123.347 27.5014 123.813 27.5959 124.199 27.7848C124.586 27.9692 124.906 28.2076 125.158 28.5C125.409 28.7924 125.601 29.096 125.731 29.4109H125.799V24.1818H129.098V38H125.832V36.32H125.731C125.592 36.6393 125.394 36.9384 125.137 37.2173C124.881 37.4962 124.559 37.7211 124.172 37.892C123.79 38.063 123.338 38.1484 122.816 38.1484ZM123.963 35.5778C124.364 35.5778 124.706 35.4653 124.989 35.2404C125.272 35.011 125.49 34.6894 125.643 34.2756C125.796 33.8617 125.873 33.3759 125.873 32.8182C125.873 32.2514 125.796 31.7634 125.643 31.354C125.495 30.9447 125.277 30.6299 124.989 30.4094C124.706 30.189 124.364 30.0788 123.963 30.0788C123.554 30.0788 123.208 30.1913 122.924 30.4162C122.641 30.6411 122.425 30.9582 122.277 31.3675C122.133 31.7769 122.061 32.2604 122.061 32.8182C122.061 33.3759 122.135 33.8617 122.283 34.2756C122.432 34.6894 122.645 35.011 122.924 35.2404C123.208 35.4653 123.554 35.5778 123.963 35.5778Z" fill="white" />
            <path d="M31 31.5L12 42L12 21L31 31.5Z" fill="white" />
        </svg>
    )
}

export const Webinar = () => {
    return (
        <svg width="151" height="62" viewBox="0 0 151 62" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M151 13.5625C151 6.07213 143.606 0 134.484 0C106.519 0 44.4813 0 16.5156 0C7.39428 0 0 6.07213 0 13.5625V48.4375C0 55.9279 7.39428 62 16.5156 62H134.484C143.606 62 151 55.9279 151 48.4375C151 38.3082 151 23.6918 151 13.5625Z" fill="#76CD4E" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.5096 44.7001C11.2353 37.138 11.2353 24.862 18.5096 17.3C19.2365 16.5444 19.2365 15.316 18.5096 14.5604C17.7827 13.8028 16.6011 13.8028 15.8742 14.5604C7.14609 23.6337 7.14609 38.3664 15.8742 47.4397C16.6011 48.1973 17.7827 48.1973 18.5096 47.4397C19.2365 46.6841 19.2365 45.4557 18.5096 44.7001Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M44.8577 17.3C52.132 24.862 52.132 37.138 44.8577 44.7001C44.1308 45.4557 44.1308 46.6841 44.8577 47.4397C45.5845 48.1973 46.7662 48.1973 47.4931 47.4397C56.2212 38.3664 56.2212 23.6337 47.4931 14.5604C46.7662 13.8028 45.5845 13.8028 44.8577 14.5604C44.1308 15.316 44.1308 16.5444 44.8577 17.3Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.7729 39.2206C19.4098 34.683 19.4098 27.3166 23.7729 22.779C24.5016 22.0234 24.5016 20.795 23.7729 20.0394C23.046 19.2838 21.8644 19.2838 21.1375 20.0394C15.3187 26.0882 15.3187 35.9114 21.1375 41.9602C21.8644 42.7159 23.046 42.7159 23.7729 41.9602C24.5016 41.2046 24.5016 39.9762 23.7729 39.2206Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M39.6012 22.779C43.9644 27.3166 43.9644 34.683 39.6012 39.2206C38.8725 39.9762 38.8725 41.2046 39.6012 41.9602C40.3281 42.7159 41.5098 42.7159 42.2366 41.9602C48.0554 35.9114 48.0554 26.0882 42.2366 20.0394C41.5098 19.2838 40.3281 19.2838 39.6012 20.0394C38.8725 20.795 38.8725 22.0234 39.6012 22.779Z" fill="white" />
            <path d="M31.6851 36.8125C34.7732 36.8125 37.2765 34.2102 37.2765 31C37.2765 27.7898 34.7732 25.1875 31.6851 25.1875C28.5971 25.1875 26.0938 27.7898 26.0938 31C26.0938 34.2102 28.5971 36.8125 31.6851 36.8125Z" fill="white" />
            <path d="M63.3587 38L59.3374 24.1818H63.0281L65.1129 33.2365H65.2276L67.6094 24.1818H70.6186L73.0004 33.2567H73.1151L75.2067 24.1818H78.8906L74.8761 38H71.6577L69.168 29.62H69.06L66.5703 38H63.3587ZM83.9645 38.1957C82.8804 38.1957 81.9448 37.982 81.1577 37.5547C80.375 37.1229 79.7723 36.5089 79.3494 35.7127C78.9311 34.9121 78.7219 33.9607 78.7219 32.8587C78.7219 31.7881 78.9334 30.8525 79.3562 30.0518C79.779 29.2467 80.375 28.6214 81.1442 28.1761C81.9134 27.7263 82.8197 27.5014 83.8633 27.5014C84.601 27.5014 85.2757 27.6161 85.8874 27.8455C86.4992 28.0749 87.0277 28.4145 87.473 28.8643C87.9183 29.3142 88.2647 29.8697 88.5121 30.5309C88.7595 31.1876 88.8832 31.9411 88.8832 32.7912V33.6143H79.8757V31.6982H85.8132C85.8087 31.3473 85.7255 31.0347 85.5636 30.7603C85.4016 30.4859 85.179 30.2723 84.8956 30.1193C84.6167 29.9619 84.2951 29.8832 83.9308 29.8832C83.5619 29.8832 83.2313 29.9664 82.9389 30.1328C82.6465 30.2947 82.4149 30.5174 82.244 30.8008C82.073 31.0797 81.9831 31.3968 81.9741 31.7521V33.7021C81.9741 34.1249 82.0573 34.496 82.2237 34.8153C82.3902 35.1302 82.6263 35.3754 82.9322 35.5508C83.238 35.7262 83.6024 35.8139 84.0252 35.8139C84.3176 35.8139 84.583 35.7734 84.8214 35.6925C85.0598 35.6115 85.2644 35.4923 85.4354 35.3349C85.6063 35.1774 85.7345 34.984 85.82 34.7546L88.8494 34.8423C88.7235 35.5215 88.4469 36.113 88.0195 36.6168C87.5967 37.1161 87.0412 37.5052 86.353 37.7841C85.6648 38.0585 84.8686 38.1957 83.9645 38.1957ZM90.5683 38V24.1818H93.8676V29.4109H93.9351C94.07 29.096 94.2612 28.7924 94.5086 28.5C94.7605 28.2076 95.0799 27.9692 95.4667 27.7848C95.858 27.5959 96.3258 27.5014 96.8701 27.5014C97.5898 27.5014 98.2623 27.6903 98.8875 28.0682C99.5173 28.446 100.026 29.0285 100.412 29.8157C100.799 30.6029 100.993 31.6059 100.993 32.8249C100.993 33.9989 100.806 34.9818 100.433 35.7734C100.064 36.5651 99.5645 37.1589 98.9347 37.5547C98.3095 37.9505 97.6146 38.1484 96.8499 38.1484C96.3281 38.1484 95.876 38.063 95.4937 37.892C95.1114 37.7211 94.7897 37.4962 94.5289 37.2173C94.2725 36.9384 94.0745 36.6393 93.9351 36.32H93.8339V38H90.5683ZM93.8002 32.8182C93.8002 33.3759 93.8744 33.8617 94.0228 34.2756C94.1758 34.6894 94.3939 35.011 94.6773 35.2404C94.9652 35.4653 95.3093 35.5778 95.7096 35.5778C96.1144 35.5778 96.4585 35.4653 96.7419 35.2404C97.0253 35.011 97.239 34.6894 97.3829 34.2756C97.5313 33.8617 97.6056 33.3759 97.6056 32.8182C97.6056 32.2604 97.5313 31.7769 97.3829 31.3675C97.239 30.9582 97.0253 30.6411 96.7419 30.4162C96.463 30.1913 96.1189 30.0788 95.7096 30.0788C95.3048 30.0788 94.9607 30.189 94.6773 30.4094C94.3939 30.6299 94.1758 30.9447 94.0228 31.354C93.8744 31.7634 93.8002 32.2514 93.8002 32.8182ZM102.722 38V27.6364H106.021V38H102.722ZM104.375 26.4286C103.911 26.4286 103.513 26.2757 103.18 25.9698C102.848 25.6594 102.681 25.2861 102.681 24.8498C102.681 24.418 102.848 24.0491 103.18 23.7433C103.513 23.4329 103.911 23.2777 104.375 23.2777C104.842 23.2777 105.241 23.4329 105.569 23.7433C105.902 24.0491 106.068 24.418 106.068 24.8498C106.068 25.2861 105.902 25.6594 105.569 25.9698C105.241 26.2757 104.842 26.4286 104.375 26.4286ZM111.42 32.0895V38H108.121V27.6364H111.258V29.5391H111.373C111.603 28.9048 111.994 28.4078 112.547 28.0479C113.1 27.6836 113.759 27.5014 114.524 27.5014C115.253 27.5014 115.885 27.6656 116.42 27.994C116.96 28.3178 117.378 28.7721 117.675 29.3569C117.976 29.9371 118.125 30.6164 118.12 31.3945V38H114.821V32.0423C114.825 31.4665 114.679 31.0167 114.382 30.6928C114.09 30.369 113.683 30.207 113.161 30.207C112.815 30.207 112.509 30.2835 112.244 30.4364C111.983 30.5849 111.78 30.7985 111.636 31.0774C111.497 31.3563 111.425 31.6937 111.42 32.0895ZM123.085 38.1754C122.423 38.1754 121.836 38.0652 121.324 37.8448C120.815 37.6199 120.413 37.2826 120.116 36.8327C119.823 36.3784 119.677 35.8094 119.677 35.1257C119.677 34.55 119.778 34.0642 119.981 33.6683C120.183 33.2725 120.462 32.9509 120.817 32.7035C121.173 32.4561 121.582 32.2694 122.045 32.1435C122.509 32.013 123.004 31.9253 123.53 31.8803C124.119 31.8263 124.594 31.7701 124.953 31.7116C125.313 31.6487 125.574 31.561 125.736 31.4485C125.903 31.3316 125.986 31.1674 125.986 30.956V30.9222C125.986 30.5759 125.867 30.3082 125.628 30.1193C125.39 29.9304 125.068 29.8359 124.663 29.8359C124.227 29.8359 123.876 29.9304 123.611 30.1193C123.345 30.3082 123.177 30.5691 123.105 30.902L120.062 30.794C120.152 30.1643 120.383 29.602 120.757 29.1072C121.135 28.608 121.652 28.2166 122.309 27.9332C122.97 27.6454 123.764 27.5014 124.69 27.5014C125.352 27.5014 125.961 27.5801 126.519 27.7376C127.077 27.8905 127.562 28.1154 127.976 28.4123C128.39 28.7047 128.709 29.0645 128.934 29.4918C129.164 29.9192 129.278 30.4072 129.278 30.956V38H126.175V36.5561H126.094C125.909 36.907 125.673 37.2038 125.385 37.4467C125.102 37.6896 124.767 37.8718 124.38 37.9933C123.998 38.1147 123.566 38.1754 123.085 38.1754ZM124.103 36.0163C124.459 36.0163 124.778 35.9444 125.061 35.8004C125.349 35.6565 125.579 35.4586 125.75 35.2067C125.921 34.9503 126.006 34.6534 126.006 34.3161V33.331C125.912 33.3804 125.797 33.4254 125.662 33.4659C125.531 33.5064 125.388 33.5446 125.23 33.5806C125.073 33.6166 124.911 33.6481 124.744 33.6751C124.578 33.7021 124.418 33.7268 124.265 33.7493C123.955 33.7988 123.69 33.8752 123.469 33.9787C123.253 34.0821 123.087 34.2171 122.97 34.3835C122.857 34.5455 122.801 34.7389 122.801 34.9638C122.801 35.3056 122.923 35.5665 123.165 35.7464C123.413 35.9264 123.725 36.0163 124.103 36.0163ZM131.296 38V27.6364H134.501V29.5256H134.609C134.798 28.8419 135.106 28.3336 135.533 28.0007C135.96 27.6634 136.457 27.4947 137.024 27.4947C137.177 27.4947 137.335 27.5059 137.496 27.5284C137.658 27.5464 137.809 27.5756 137.949 27.6161V30.4837C137.791 30.4297 137.584 30.387 137.328 30.3555C137.076 30.324 136.851 30.3082 136.653 30.3082C136.262 30.3082 135.909 30.396 135.594 30.5714C135.283 30.7423 135.038 30.983 134.858 31.2933C134.683 31.5992 134.595 31.959 134.595 32.3729V38H131.296Z" fill="white" />
        </svg>

    )
}


export const FreeWebinar = () => {
    return (
        <svg width="151" height="62" viewBox="0 0 151 62" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M151 13.5625C151 6.07213 143.606 0 134.484 0C106.519 0 44.4813 0 16.5156 0C7.39428 0 0 6.07213 0 13.5625V48.4375C0 55.9279 7.39428 62 16.5156 62H134.484C143.606 62 151 55.9279 151 48.4375C151 38.3082 151 23.6918 151 13.5625Z" fill="#76CD4E" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.5096 44.7001C11.2353 37.138 11.2353 24.862 18.5096 17.3C19.2365 16.5444 19.2365 15.316 18.5096 14.5604C17.7827 13.8028 16.6011 13.8028 15.8742 14.5604C7.14609 23.6337 7.14609 38.3664 15.8742 47.4397C16.6011 48.1973 17.7827 48.1973 18.5096 47.4397C19.2365 46.6841 19.2365 45.4557 18.5096 44.7001Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M44.8577 17.3C52.132 24.862 52.132 37.138 44.8577 44.7001C44.1308 45.4557 44.1308 46.6841 44.8577 47.4397C45.5845 48.1973 46.7662 48.1973 47.4931 47.4397C56.2212 38.3664 56.2212 23.6337 47.4931 14.5604C46.7662 13.8028 45.5845 13.8028 44.8577 14.5604C44.1308 15.316 44.1308 16.5444 44.8577 17.3Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.7729 39.2206C19.4098 34.683 19.4098 27.3166 23.7729 22.779C24.5016 22.0234 24.5016 20.795 23.7729 20.0394C23.046 19.2838 21.8644 19.2838 21.1375 20.0394C15.3187 26.0882 15.3187 35.9114 21.1375 41.9602C21.8644 42.7159 23.046 42.7159 23.7729 41.9602C24.5016 41.2046 24.5016 39.9762 23.7729 39.2206Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M39.6012 22.779C43.9644 27.3166 43.9644 34.683 39.6012 39.2206C38.8725 39.9762 38.8725 41.2046 39.6012 41.9602C40.3281 42.7159 41.5098 42.7159 42.2366 41.9602C48.0554 35.9114 48.0554 26.0882 42.2366 20.0394C41.5098 19.2838 40.3281 19.2838 39.6012 20.0394C38.8725 20.795 38.8725 22.0234 39.6012 22.779Z" fill="white" />
            <path d="M31.6851 36.8125C34.7732 36.8125 37.2765 34.2102 37.2765 31C37.2765 27.7898 34.7732 25.1875 31.6851 25.1875C28.5971 25.1875 26.0938 27.7898 26.0938 31C26.0938 34.2102 28.5971 36.8125 31.6851 36.8125Z" fill="white" />
            <path d="M63.3587 38L59.3374 24.1818H63.0281L65.1129 33.2365H65.2276L67.6094 24.1818H70.6186L73.0004 33.2567H73.1151L75.2067 24.1818H78.8906L74.8761 38H71.6577L69.168 29.62H69.06L66.5703 38H63.3587ZM83.9645 38.1957C82.8804 38.1957 81.9448 37.982 81.1577 37.5547C80.375 37.1229 79.7723 36.5089 79.3494 35.7127C78.9311 34.9121 78.7219 33.9607 78.7219 32.8587C78.7219 31.7881 78.9334 30.8525 79.3562 30.0518C79.779 29.2467 80.375 28.6214 81.1442 28.1761C81.9134 27.7263 82.8197 27.5014 83.8633 27.5014C84.601 27.5014 85.2757 27.6161 85.8874 27.8455C86.4992 28.0749 87.0277 28.4145 87.473 28.8643C87.9183 29.3142 88.2647 29.8697 88.5121 30.5309C88.7595 31.1876 88.8832 31.9411 88.8832 32.7912V33.6143H79.8757V31.6982H85.8132C85.8087 31.3473 85.7255 31.0347 85.5636 30.7603C85.4016 30.4859 85.179 30.2723 84.8956 30.1193C84.6167 29.9619 84.2951 29.8832 83.9308 29.8832C83.5619 29.8832 83.2313 29.9664 82.9389 30.1328C82.6465 30.2947 82.4149 30.5174 82.244 30.8008C82.073 31.0797 81.9831 31.3968 81.9741 31.7521V33.7021C81.9741 34.1249 82.0573 34.496 82.2237 34.8153C82.3902 35.1302 82.6263 35.3754 82.9322 35.5508C83.238 35.7262 83.6024 35.8139 84.0252 35.8139C84.3176 35.8139 84.583 35.7734 84.8214 35.6925C85.0598 35.6115 85.2644 35.4923 85.4354 35.3349C85.6063 35.1774 85.7345 34.984 85.82 34.7546L88.8494 34.8423C88.7235 35.5215 88.4469 36.113 88.0195 36.6168C87.5967 37.1161 87.0412 37.5052 86.353 37.7841C85.6648 38.0585 84.8686 38.1957 83.9645 38.1957ZM90.5683 38V24.1818H93.8676V29.4109H93.9351C94.07 29.096 94.2612 28.7924 94.5086 28.5C94.7605 28.2076 95.0799 27.9692 95.4667 27.7848C95.858 27.5959 96.3258 27.5014 96.8701 27.5014C97.5898 27.5014 98.2623 27.6903 98.8875 28.0682C99.5173 28.446 100.026 29.0285 100.412 29.8157C100.799 30.6029 100.993 31.6059 100.993 32.8249C100.993 33.9989 100.806 34.9818 100.433 35.7734C100.064 36.5651 99.5645 37.1589 98.9347 37.5547C98.3095 37.9505 97.6146 38.1484 96.8499 38.1484C96.3281 38.1484 95.876 38.063 95.4937 37.892C95.1114 37.7211 94.7897 37.4962 94.5289 37.2173C94.2725 36.9384 94.0745 36.6393 93.9351 36.32H93.8339V38H90.5683ZM93.8002 32.8182C93.8002 33.3759 93.8744 33.8617 94.0228 34.2756C94.1758 34.6894 94.3939 35.011 94.6773 35.2404C94.9652 35.4653 95.3093 35.5778 95.7096 35.5778C96.1144 35.5778 96.4585 35.4653 96.7419 35.2404C97.0253 35.011 97.239 34.6894 97.3829 34.2756C97.5313 33.8617 97.6056 33.3759 97.6056 32.8182C97.6056 32.2604 97.5313 31.7769 97.3829 31.3675C97.239 30.9582 97.0253 30.6411 96.7419 30.4162C96.463 30.1913 96.1189 30.0788 95.7096 30.0788C95.3048 30.0788 94.9607 30.189 94.6773 30.4094C94.3939 30.6299 94.1758 30.9447 94.0228 31.354C93.8744 31.7634 93.8002 32.2514 93.8002 32.8182ZM102.722 38V27.6364H106.021V38H102.722ZM104.375 26.4286C103.911 26.4286 103.513 26.2757 103.18 25.9698C102.848 25.6594 102.681 25.2861 102.681 24.8498C102.681 24.418 102.848 24.0491 103.18 23.7433C103.513 23.4329 103.911 23.2777 104.375 23.2777C104.842 23.2777 105.241 23.4329 105.569 23.7433C105.902 24.0491 106.068 24.418 106.068 24.8498C106.068 25.2861 105.902 25.6594 105.569 25.9698C105.241 26.2757 104.842 26.4286 104.375 26.4286ZM111.42 32.0895V38H108.121V27.6364H111.258V29.5391H111.373C111.603 28.9048 111.994 28.4078 112.547 28.0479C113.1 27.6836 113.759 27.5014 114.524 27.5014C115.253 27.5014 115.885 27.6656 116.42 27.994C116.96 28.3178 117.378 28.7721 117.675 29.3569C117.976 29.9371 118.125 30.6164 118.12 31.3945V38H114.821V32.0423C114.825 31.4665 114.679 31.0167 114.382 30.6928C114.09 30.369 113.683 30.207 113.161 30.207C112.815 30.207 112.509 30.2835 112.244 30.4364C111.983 30.5849 111.78 30.7985 111.636 31.0774C111.497 31.3563 111.425 31.6937 111.42 32.0895ZM123.085 38.1754C122.423 38.1754 121.836 38.0652 121.324 37.8448C120.815 37.6199 120.413 37.2826 120.116 36.8327C119.823 36.3784 119.677 35.8094 119.677 35.1257C119.677 34.55 119.778 34.0642 119.981 33.6683C120.183 33.2725 120.462 32.9509 120.817 32.7035C121.173 32.4561 121.582 32.2694 122.045 32.1435C122.509 32.013 123.004 31.9253 123.53 31.8803C124.119 31.8263 124.594 31.7701 124.953 31.7116C125.313 31.6487 125.574 31.561 125.736 31.4485C125.903 31.3316 125.986 31.1674 125.986 30.956V30.9222C125.986 30.5759 125.867 30.3082 125.628 30.1193C125.39 29.9304 125.068 29.8359 124.663 29.8359C124.227 29.8359 123.876 29.9304 123.611 30.1193C123.345 30.3082 123.177 30.5691 123.105 30.902L120.062 30.794C120.152 30.1643 120.383 29.602 120.757 29.1072C121.135 28.608 121.652 28.2166 122.309 27.9332C122.97 27.6454 123.764 27.5014 124.69 27.5014C125.352 27.5014 125.961 27.5801 126.519 27.7376C127.077 27.8905 127.562 28.1154 127.976 28.4123C128.39 28.7047 128.709 29.0645 128.934 29.4918C129.164 29.9192 129.278 30.4072 129.278 30.956V38H126.175V36.5561H126.094C125.909 36.907 125.673 37.2038 125.385 37.4467C125.102 37.6896 124.767 37.8718 124.38 37.9933C123.998 38.1147 123.566 38.1754 123.085 38.1754ZM124.103 36.0163C124.459 36.0163 124.778 35.9444 125.061 35.8004C125.349 35.6565 125.579 35.4586 125.75 35.2067C125.921 34.9503 126.006 34.6534 126.006 34.3161V33.331C125.912 33.3804 125.797 33.4254 125.662 33.4659C125.531 33.5064 125.388 33.5446 125.23 33.5806C125.073 33.6166 124.911 33.6481 124.744 33.6751C124.578 33.7021 124.418 33.7268 124.265 33.7493C123.955 33.7988 123.69 33.8752 123.469 33.9787C123.253 34.0821 123.087 34.2171 122.97 34.3835C122.857 34.5455 122.801 34.7389 122.801 34.9638C122.801 35.3056 122.923 35.5665 123.165 35.7464C123.413 35.9264 123.725 36.0163 124.103 36.0163ZM131.296 38V27.6364H134.501V29.5256H134.609C134.798 28.8419 135.106 28.3336 135.533 28.0007C135.96 27.6634 136.457 27.4947 137.024 27.4947C137.177 27.4947 137.335 27.5059 137.496 27.5284C137.658 27.5464 137.809 27.5756 137.949 27.6161V30.4837C137.791 30.4297 137.584 30.387 137.328 30.3555C137.076 30.324 136.851 30.3082 136.653 30.3082C136.262 30.3082 135.909 30.396 135.594 30.5714C135.283 30.7423 135.038 30.983 134.858 31.2933C134.683 31.5992 134.595 31.959 134.595 32.3729V38H131.296Z" fill="white" />
        </svg>

    )
}